(function () {
  const slideAudit = [
    { slide: 1, label: "VIDEO HERO" },
    { slide: 3, label: "FULL COMMERCE ECOSYSTEM" },
    { slide: 4, label: "SERVICE DETAILS" },
    { slide: 5, label: "CROSSBORDER USA" },
    { slide: 6, label: "OK! MAS GRANDE QUANTO?" },
    { slide: 7, label: "MARKET COMPARISON" },
    { slide: 8, label: "ECOMMERCE GROWTH + PENETRATION" },
    { slide: 10, label: "CROSSBORDER OPERATION FLOW" },
    { slide: 11, label: "CASES SHOWCASE" },
    { slide: 15, label: "AKAG BRAND STORY" },
    { slide: 16, label: "SOME CLIENTS" },
    { slide: 23, label: "US > GLOBAL" }
  ];

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const navEntry = performance.getEntriesByType?.("navigation")?.[0];
  const isReloadNavigation = navEntry ? navEntry.type === "reload" : performance.navigation?.type === 1;
  const reloadScrollTopKey = "akag:reload-scroll-top";
  let shouldForceStartupTop = isReloadNavigation;
  try {
    shouldForceStartupTop = shouldForceStartupTop || sessionStorage.getItem(reloadScrollTopKey) === "1";
    sessionStorage.removeItem(reloadScrollTopKey);
  } catch (error) {
    /* sessionStorage pode estar indisponivel em alguns previews */
  }
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  if (shouldForceStartupTop) {
    window.scrollTo(0, 0);
  }
  const slidesRepresented = Array.from(document.querySelectorAll("[data-slide]")).map((section) =>
    Number(section.dataset.slide)
  );
  const allSlidesRepresented = slideAudit.every(({ slide }) => slidesRepresented.includes(slide));

  document.documentElement.dataset.slideAudit = allSlidesRepresented ? "complete" : "incomplete";

  const projectWallProjects = [
    [
      { title: "PKXD", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/pkxd.webp"]) || "assets/cases/pkxd.webp", modifier: "aurum" },
      { title: "4Music", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/4music.webp"]) || "assets/cases/4music.webp", modifier: "livre" },
      { title: "Moose", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/moose.webp"]) || "assets/cases/moose.webp", modifier: "petzin" },
      { title: "Asics", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/asics.webp"]) || "assets/cases/asics.webp", modifier: "home" },
      { title: "Samsonite", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/samsonite.webp"]) || "assets/cases/samsonite.webp", modifier: "atelier" }
    ],
    [
      { title: "Ohpen", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/ohpen.webp"]) || "assets/cases/ohpen.webp", modifier: "pureskin" },
      { title: "Kontenta", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/kontenta.webp"]) || "assets/cases/kontenta.webp", modifier: "wildgear" },
      { title: "Carnan", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/carnan.webp"]) || "assets/cases/carnan.webp", modifier: "nitro" },
      { title: "Ellesse", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/ellessee.webp"]) || "assets/cases/ellessee.webp", modifier: "chef" },
      { title: "Apice", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/apice.webp"]) || "assets/cases/apice.webp", modifier: "sport" }
    ],
    [
      { title: "Class", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/class.webp"]) || "assets/cases/class.webp", modifier: "altitude" },
      { title: "Rove Lab", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/rove-lab.webp"]) || "assets/cases/rove-lab.webp", modifier: "frete" },
      { title: "APISVIDA", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/mockups/apisvida-desktop-mockup.png"]) || "assets/mockups/apisvida-desktop-mockup.png", modifier: "journey" },
      { title: "HPG", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/hpg.webp"]) || "assets/cases/hpg.webp", modifier: "wellness" },
      { title: "PKXD", image: (window.AKAG_ASSETS && window.AKAG_ASSETS["assets/cases/pkxd.webp"]) || "assets/cases/pkxd.webp", modifier: "kids" }
    ]
  ];

  function renderProjectWallMosaic() {
    document.querySelectorAll(".projects-mosaic__row").forEach((row, rowIndex) => {
      if (row.children.length) return;

      const projects = projectWallProjects[rowIndex] || [];
      row.innerHTML = projects.map((project) => `
        <figure class="project-shot project-shot--${project.modifier}" data-project-title="${project.title}">
          <img src="${project.image}" alt="" loading="lazy" />
        </figure>
      `).join("");
    });
  }

  renderProjectWallMosaic();
  initCaseShowcaseVideos();

  const ecosystemDesktopPaths = {
    consultoria: "M500 350 C438 286 360 210 268 171",
    marketing: "M500 350 C562 286 640 210 732 171",
    exportacao: "M500 350 C626 330 724 338 860 350",
    fulfillment: "M500 350 C562 426 638 506 730 529",
    suporte: "M500 350 C438 426 362 506 270 529",
    implantacao: "M500 350 C374 330 276 338 140 350"
  };
  const ecosystemTopServices = new Set(["consultoria", "marketing"]);
  const ecosystemBottomServices = new Set(["suporte", "fulfillment"]);
  const ecosystemDesktopMeasuredServices = new Set(["consultoria", "marketing", "suporte", "fulfillment"]);
  const ecosystemCenterPoint = { x: 500, y: 350 };

  function getEcosystemSvgPoint(network, clientX, clientY) {
    const point = network.createSVGPoint();
    point.x = clientX;
    point.y = clientY;

    const matrix = network.getScreenCTM();
    if (matrix) return point.matrixTransform(matrix.inverse());

    const rect = network.getBoundingClientRect();
    const [, , viewBoxWidth, viewBoxHeight] = network.getAttribute("viewBox").split(/\s+/).map(Number);
    return {
      x: ((clientX - rect.left) / rect.width) * viewBoxWidth,
      y: ((clientY - rect.top) / rect.height) * viewBoxHeight
    };
  }

  function getEcosystemVisualRect(element) {
    const rect = element.getBoundingClientRect();

    if (typeof element.getBBox !== "function" || typeof element.getScreenCTM !== "function") return rect;

    try {
      const box = element.getBBox();
      const matrix = element.getScreenCTM();
      if (!matrix || (!box.width && !box.height)) return rect;

      const points = [
        new DOMPoint(box.x, box.y).matrixTransform(matrix),
        new DOMPoint(box.x + box.width, box.y).matrixTransform(matrix),
        new DOMPoint(box.x + box.width, box.y + box.height).matrixTransform(matrix),
        new DOMPoint(box.x, box.y + box.height).matrixTransform(matrix)
      ];
      const xs = points.map((point) => point.x);
      const ys = points.map((point) => point.y);
      const strokePad = 2;
      const left = Math.min(...xs) - strokePad;
      const top = Math.min(...ys) - strokePad;
      const right = Math.max(...xs) + strokePad;
      const bottom = Math.max(...ys) + strokePad;

      return {
        left,
        top,
        right,
        bottom,
        width: right - left,
        height: bottom - top
      };
    } catch (error) {
      return rect;
    }
  }

  function getEcosystemIconTarget(section, network, service) {
    const hub = section.querySelector(".ecosystem-hub");
    const icon =
      section.querySelector(`.service-node[data-service="${service}"] .service-icon`) ||
      section.querySelector(`.service-node[data-service="${service}"] .service-anchor`);
    if (!hub || !icon) return null;

    const hubRect = hub.getBoundingClientRect();
    const iconRect = getEcosystemVisualRect(icon);
    const source = {
      x: hubRect.left + hubRect.width / 2,
      y: hubRect.top + hubRect.height / 2
    };
    const iconCenter = {
      x: iconRect.left + iconRect.width / 2,
      y: iconRect.top + iconRect.height / 2
    };
    const deltaX = iconCenter.x - source.x;
    const deltaY = iconCenter.y - source.y;
    const distance = Math.hypot(deltaX, deltaY) || 1;
    const unitX = deltaX / distance;
    const unitY = deltaY / distance;
    const edgeDistance = Math.min(
      Math.abs(unitX) > 0.001 ? iconRect.width / 2 / Math.abs(unitX) : Number.POSITIVE_INFINITY,
      Math.abs(unitY) > 0.001 ? iconRect.height / 2 / Math.abs(unitY) : Number.POSITIVE_INFINITY
    );
    const target = {
      x: iconCenter.x - unitX * edgeDistance,
      y: iconCenter.y - unitY * edgeDistance
    };

    return {
      source: getEcosystemSvgPoint(network, source.x, source.y),
      target: getEcosystemSvgPoint(network, target.x, target.y)
    };
  }

  function getEcosystemServicePath(section, network, service, fallbackPaths = ecosystemDesktopPaths) {
    if (!ecosystemDesktopMeasuredServices.has(service)) return fallbackPaths[service];

    const points = getEcosystemIconTarget(section, network, service);
    if (!points) return fallbackPaths[service];

    const deltaX = points.target.x - points.source.x;
    const deltaY = points.target.y - points.source.y;
    const controlA = {
      x: points.source.x + deltaX * 0.34,
      y: points.source.y + deltaY * 0.34
    };
    const controlB = {
      x: points.source.x + deltaX * 0.72,
      y: points.source.y + deltaY * 0.72
    };

    return `M${points.source.x.toFixed(1)} ${points.source.y.toFixed(1)} C${controlA.x.toFixed(1)} ${controlA.y.toFixed(1)} ${controlB.x.toFixed(1)} ${controlB.y.toFixed(1)} ${points.target.x.toFixed(1)} ${points.target.y.toFixed(1)}`;
  }

  function getEcosystemCompactIconTarget(section, network, map, service) {
    const targetElement =
      section.querySelector(`.service-node[data-service="${service}"] .service-icon`) ||
      section.querySelector(`.service-node[data-service="${service}"] .service-anchor`);
    if (!targetElement) return null;

    const mapRect = map.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();
    const [, , viewBoxWidth, viewBoxHeight] = network.getAttribute("viewBox").split(/\s+/).map(Number);
    const centerX = mapRect.left + (ecosystemCenterPoint.x / viewBoxWidth) * mapRect.width;
    const centerY = mapRect.top + (ecosystemCenterPoint.y / viewBoxHeight) * mapRect.height;
    const iconCenterX = targetRect.left + targetRect.width / 2;
    const iconCenterY = targetRect.top + targetRect.height / 2;
    const deltaX = iconCenterX - centerX;
    const deltaY = iconCenterY - centerY;
    const distance = Math.hypot(deltaX, deltaY) || 1;
    const unitX = deltaX / distance;
    const unitY = deltaY / distance;
    const edgeDistance = Math.min(
      Math.abs(unitX) > 0.001 ? targetRect.width / 2 / Math.abs(unitX) : Number.POSITIVE_INFINITY,
      Math.abs(unitY) > 0.001 ? targetRect.height / 2 / Math.abs(unitY) : Number.POSITIVE_INFINITY
    );
    const targetX = iconCenterX - unitX * (edgeDistance + 4);
    const targetY = iconCenterY - unitY * (edgeDistance + 4);

    return {
      x: ((targetX - mapRect.left) / mapRect.width) * viewBoxWidth,
      y: ((targetY - mapRect.top) / mapRect.height) * viewBoxHeight
    };
  }

  function getEcosystemCompactPath(section, network, map, service, fallbackPaths = ecosystemDesktopPaths) {
    const target = getEcosystemCompactIconTarget(section, network, map, service);
    if (!target) return fallbackPaths[service];

    const controlY =
      ecosystemTopServices.has(service)
        ? ecosystemCenterPoint.y - Math.abs(ecosystemCenterPoint.y - target.y) * 0.66
        : ecosystemBottomServices.has(service)
          ? ecosystemCenterPoint.y + Math.abs(ecosystemCenterPoint.y - target.y) * 0.66
          : target.y - (target.y - ecosystemCenterPoint.y) * 0.22;
    const controlA = {
      x: ecosystemCenterPoint.x + (target.x - ecosystemCenterPoint.x) * 0.34,
      y: ecosystemCenterPoint.y + (controlY - ecosystemCenterPoint.y) * 0.8
    };
    const controlB = {
      x: ecosystemCenterPoint.x + (target.x - ecosystemCenterPoint.x) * 0.72,
      y: controlY
    };

    return `M${ecosystemCenterPoint.x} ${ecosystemCenterPoint.y} C${controlA.x.toFixed(1)} ${controlA.y.toFixed(1)} ${controlB.x.toFixed(1)} ${controlB.y.toFixed(1)} ${target.x.toFixed(1)} ${target.y.toFixed(1)}`;
  }

  function syncEcosystemResponsivePaths() {
    const section = document.querySelector(".ecosystem");
    const network = section?.querySelector(".ecosystem-network");
    const map = section?.querySelector(".ecosystem-map");
    const links = Array.from(section?.querySelectorAll(".ecosystem-link") || []);
    const isCompact = window.matchMedia("(max-width: 1023px), (hover: none) and (pointer: coarse)").matches;

    if (!section || !network || !map || !links.length) return;

    network.setAttribute("preserveAspectRatio", isCompact ? "none" : "xMidYMid meet");

    links.forEach((path) => {
      const service = path.dataset.service;
      if (!service) return;
      path.setAttribute(
        "d",
        isCompact
          ? getEcosystemCompactPath(section, network, map, service)
          : getEcosystemServicePath(section, network, service)
      );
    });
  }

  syncEcosystemResponsivePaths();
  window.addEventListener("resize", () => requestAnimationFrame(syncEcosystemResponsivePaths), { passive: true });
  document.fonts?.ready.then(syncEcosystemResponsivePaths);
  if ("ResizeObserver" in window) {
    const ecosystem = document.querySelector(".ecosystem");
    const ecosystemMap = ecosystem?.querySelector(".ecosystem-map");
    const ecosystemPathObserver = new ResizeObserver(() => requestAnimationFrame(syncEcosystemResponsivePaths));
    if (ecosystem) ecosystemPathObserver.observe(ecosystem);
    if (ecosystemMap) ecosystemPathObserver.observe(ecosystemMap);
  }

  function getAnchorScrollElement(target) {
    let node = target;
    while (node && node !== document.body) {
      if (node.parentElement?.classList.contains("pin-spacer")) {
        return node.parentElement;
      }
      node = node.parentElement;
    }
    return target;
  }

  let anchorScrollTween;
  let pendingAnchorTarget = null;
  let pendingAnchorUntil = 0;

  function forcePageTop() {
    pendingAnchorTarget = null;
    pendingAnchorUntil = 0;
    if (anchorScrollTween) {
      anchorScrollTween.kill();
      anchorScrollTween = null;
    }
    window.scrollTo(0, 0);
    if (window.ScrollTrigger) ScrollTrigger.update();
  }

  function getFocusContactTarget() {
    if (window.AKAG_FOCUS_CONTACT) {
      return document.getElementById("contact");
    }
    if (document.querySelector(".contact-form-status--ok, .contact-form-status--error")) {
      return document.getElementById("contact");
    }
    const hash = location.hash;
    if (hash === "#contact" || hash === "#contact-form" || hash === "#ContactForm") {
      return document.getElementById("contact");
    }
    return null;
  }

  function getStartupAnchorTarget() {
    if (shouldForceStartupTop) return null;

    const contactTarget = getFocusContactTarget();
    if (contactTarget) return contactTarget;

    const hash = location.hash;
    if (hash && hash.length > 1) {
      const el = document.querySelector(hash);
      if (el) return el.closest("main section[data-nav-theme]") || el;
    }
    return null;
  }

  function lockPendingAnchor(target, ms = 2200) {
    if (!target) return;
    pendingAnchorTarget = target;
    pendingAnchorUntil = performance.now() + ms;
  }

  function applyPendingAnchor() {
    if (!pendingAnchorTarget) return;
    if (performance.now() > pendingAnchorUntil) {
      pendingAnchorTarget = null;
      return;
    }
    scrollToAnchor(pendingAnchorTarget, { behavior: "auto", updateHash: false });
  }

  function getAnchorScrollY(target) {
    if (!target) return 0;

    if (window.ScrollTrigger && window.gsap && ScrollTrigger.getAll) {
      try {
        ScrollTrigger.update();
        // Temporary trigger: start accounts for every pin-spacer already in the page.
        const probe = ScrollTrigger.create({
          trigger: target,
          start: "top top"
        });
        const y = probe.start;
        probe.kill();
        if (typeof y === "number" && !Number.isNaN(y)) return y;
      } catch (error) {
        /* fall through to geometry measure */
      }
    }

    const box = getAnchorScrollElement(target);
    return box.getBoundingClientRect().top + window.pageYOffset;
  }

  function scrollToAnchor(target, { behavior, updateHash } = {}) {
    if (!target) return;

    const preferAuto = behavior === "auto" || reduceMotion;
    const y = Math.max(0, Math.round(getAnchorScrollY(target)));
    const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (anchorScrollTween) {
      anchorScrollTween.kill();
      anchorScrollTween = null;
    }

    // Native behavior:"smooth" aborts when ScrollTrigger pins/unpins mid-flight
    // (contact / cases / etc. were landing inside operation-flow). Drive scroll ourselves.
    if (preferAuto || !window.gsap || Math.abs(y - currentY) < 2) {
      window.scrollTo(0, y);
    } else {
      const proxy = { y: currentY };
      const distance = Math.abs(y - currentY);
      const duration = Math.min(1.55, Math.max(0.45, distance / 3200));
      anchorScrollTween = window.gsap.to(proxy, {
        y,
        duration,
        ease: "power2.inOut",
        overwrite: true,
        onUpdate: () => {
          window.scrollTo(0, proxy.y);
        },
        onComplete: () => {
          anchorScrollTween = null;
          window.scrollTo(0, y);
          if (window.ScrollTrigger) ScrollTrigger.update();
        }
      });
    }

    if (updateHash !== false && target.id) {
      const nextHash = `#${target.id}`;
      if (location.hash !== nextHash) {
        history.pushState(null, "", nextHash);
      }
    }
  }

  window.AKAG = window.AKAG || {};
  window.AKAG.scrollToAnchor = scrollToAnchor;

  function initSectionNavigation() {
    const nav = document.querySelector(".site-section-nav");
    const railButton = nav?.querySelector(".nav-rail");
    const currentIndex = nav?.querySelector("[data-nav-current-index]");
    const currentLabel = nav?.querySelector("[data-nav-current-label]");
    const links = Array.from(document.querySelectorAll("[data-section-link]"));
    const themedSections = Array.from(document.querySelectorAll("main section[data-nav-theme]"));
    const mobileNavQuery = window.matchMedia("(max-width: 760px)");

    if (!nav || !links.length || !themedSections.length) return;

    const sectionMeta = {
      hero: { index: "01", label: "Full Commerce" },
      ecosystem: { index: "02", label: "Pilares da AKAG" },
      "service-detail": { index: "03", label: "Serviços" },
      "crossborder-usa": { index: "04", label: "Full Commerce USA" },
      "ok-break": { index: "05", label: "Mercado US" },
      "market-comparison": { index: "05", label: "Mercado US" },
      "ecommerce-growth": { index: "06", label: "E-commerce" },
      "global-final": { index: "07", label: "Global" },
      "operation-flow": { index: "08", label: "Fluxo" },
      "project-wall": { index: "09", label: "Cases" },
      "cases-showcase": { index: "09", label: "Cases" },
      "brand-story": { index: "10", label: "História da AKAG" },
      clients: { index: "11", label: "Clientes" },
      contact: { index: "12", label: "Contato" }
    };
    const activeLinkTargets = {
      "ok-break": "market-comparison",
      "project-wall": "cases-showcase"
    };
    let closeTimer;

    const linkedSections = links
      .map((link) => {
        const target = document.querySelector(link.getAttribute("href"));
        return target ? { link, target } : null;
      })
      .filter(Boolean);

    if (!linkedSections.length) return;

    const openNav = () => {
      if (nav.classList.contains("nav--hero") && !mobileNavQuery.matches) return;
      window.clearTimeout(closeTimer);
      nav.classList.add("nav--open");
      if (mobileNavQuery.matches) document.body.classList.add("nav-drawer-open");
      railButton?.setAttribute("aria-expanded", "true");
      railButton?.setAttribute("aria-label", "Fechar navegação");
    };

    const closeNav = () => {
      window.clearTimeout(closeTimer);
      nav.classList.remove("nav--open");
      document.body.classList.remove("nav-drawer-open");
      railButton?.setAttribute("aria-expanded", "false");
      railButton?.setAttribute("aria-label", "Abrir navegação");
    };

    const scheduleClose = () => {
      if (nav.classList.contains("nav--hero") || mobileNavQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeNav, 180);
    };

    const setActive = (id) => {
      const activeSection = document.getElementById(id);
      const theme = activeSection?.dataset.navTheme === "light" ? "light" : "dark";
      const isHero = id === "hero";
      const meta = sectionMeta[id] || { index: "--", label: activeSection?.getAttribute("aria-label") || id };

      nav.classList.toggle("nav--light", theme === "light");
      nav.classList.toggle("nav--dark", theme !== "light");
      nav.classList.toggle("nav--hero", isHero);
      nav.classList.toggle("nav--collapsed", !isHero);
      nav.dataset.theme = theme;
      nav.dataset.activeSection = id;

      if (currentIndex) currentIndex.textContent = meta.index;
      if (currentLabel) currentLabel.textContent = meta.label;
      if (isHero && !nav.classList.contains("nav--open")) closeNav();

      linkedSections.forEach(({ link }) => {
        const activeLinkId = activeLinkTargets[id] || id;
        const isActive = link.getAttribute("href") === `#${activeLinkId}`;
        link.classList.toggle("is-active", isActive);
        if (isActive) {
          link.setAttribute("aria-current", "true");
          if (nav.contains(link) && window.matchMedia("(max-width: 760px)").matches) {
            link.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", inline: "center", block: "nearest" });
          }
        } else {
          link.removeAttribute("aria-current");
        }
      });
    };

    const goToSection = (target) => {
      if (!target) return;
      scrollToAnchor(target);
      const section = target.closest("main section[data-nav-theme]") || target;
      if (section?.id) setActive(section.id);
      closeNav();
    };

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href");
        if (!href || !href.startsWith("#") || href === "#") return;
        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        goToSection(target);
      });
    });

    document.addEventListener("click", (event) => {
      const anchor = event.target.closest?.('a[href^="#"]');
      if (!anchor || anchor.hasAttribute("data-section-link")) return;
      if (anchor.target && anchor.target !== "_self") return;

      const href = anchor.getAttribute("href");
      if (!href || href === "#" || href.startsWith("#/")) return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      goToSection(target);
    });

    railButton?.addEventListener("click", (event) => {
      event.stopPropagation();
      if (nav.classList.contains("nav--hero") && !mobileNavQuery.matches) return;
      if (nav.classList.contains("nav--open")) {
        closeNav();
      } else {
        openNav();
      }
    });

    nav.addEventListener("mouseenter", () => {
      if (!mobileNavQuery.matches) openNav();
    });
    nav.addEventListener("mouseleave", scheduleClose);
    nav.addEventListener("focusin", () => {
      if (!mobileNavQuery.matches) openNav();
    });
    nav.addEventListener("focusout", (event) => {
      if (!nav.contains(event.relatedTarget)) scheduleClose();
    });

    document.addEventListener("click", (event) => {
      if (!nav.contains(event.target)) closeNav();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeNav();
    });

    if (!("IntersectionObserver" in window)) {
      setActive(themedSections[0].id);
      return;
    }

    const visibleSections = new Map();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleSections.set(entry.target.id, entry.intersectionRatio);
        } else {
          visibleSections.delete(entry.target.id);
        }
      });

      const current = themedSections
        .filter((section) => visibleSections.has(section.id))
        .sort((a, b) => visibleSections.get(b.id) - visibleSections.get(a.id))[0];

      if (current) setActive(current.id);
    }, {
      root: null,
      rootMargin: "-36% 0px -50% 0px",
      threshold: [0.02, 0.18, 0.42, 0.68]
    });

    themedSections.forEach((section) => observer.observe(section));
    const initial = themedSections.find((section) => {
      const rect = section.getBoundingClientRect();
      return rect.top <= window.innerHeight * 0.55 && rect.bottom >= window.innerHeight * 0.42;
    }) || themedSections[0];
    setActive(initial.id);
  }

  initSectionNavigation();

  if (!window.gsap || !window.ScrollTrigger || reduceMotion) {
    document.documentElement.classList.add("reduced-motion");
    document.querySelectorAll(".hero-video").forEach((video) => {
      video.pause();
      video.removeAttribute("autoplay");
    });
    return;
  }

  const hasMotionPath = Boolean(window.MotionPathPlugin);

  if (hasMotionPath) {
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  } else {
    gsap.registerPlugin(ScrollTrigger);
  }

  gsap.defaults({ ease: "power3.out", duration: 1 });

  let operationFlowContext;
  let okBreakContext;
  let okBreakCleanup = () => {};
  let okBreakBreakpointCleanup = () => {};
  let syncOkBreakScrollState = () => {};
  let marketComparisonContext;
  let ecommerceGrowthContext;
  let serviceDetailContext;
  let projectWallContext;
  let caseShowcaseContext;
  let pkxdCaseContext;
  let apisvidaCaseContext;
  let ecosystemContext;
  let ecosystemCleanup = () => {};
  let globalContext;
  let globalRoot;
  let globalAbort;
  const projectCaseScroll = {
    pkxd: {
      start: "top 78%",
      end: "bottom 18%"
    },
    apisvida: {
      start: "top 82%",
      end: "center 48%"
    },
    scrub: 0.18
  };

  async function buildHeroWorldNetwork(hero) {
    const svg = hero.querySelector(".hero-world");
    const landGroup = hero.querySelector(".hero-map-land");
    const bordersGroup = hero.querySelector(".hero-map-borders");
    const routesGroup = hero.querySelector(".hero-routes");
    const particlesGroup = hero.querySelector(".hero-particles");
    const nodesGroup = hero.querySelector(".hero-nodes");
    const canBuildMap = svg && landGroup && bordersGroup && routesGroup && particlesGroup && nodesGroup && window.d3 && window.topojson;

    if (!canBuildMap) return;

    const svgNs = "http://www.w3.org/2000/svg";
    const setAttrs = (element, attrs) => {
      Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value));
      return element;
    };
    const makeSvg = (tag, attrs = {}) => setAttrs(document.createElementNS(svgNs, tag), attrs);

    const world = await fetch((window.AKAG_ASSETS && window.AKAG_ASSETS["assets/vendor/countries-110m.json"]) || "assets/vendor/countries-110m.json").then((response) => response.json());
    const land = topojson.feature(world, world.objects.land);
    const borders = topojson.mesh(world, world.objects.countries, (a, b) => a !== b);
    const projection = d3.geoNaturalEarth1()
      .rotate([10, 0])
      .scale(340)
      .translate([720, 450]);
    const geoPath = d3.geoPath(projection);
    const landD = geoPath(land);
    const defs = svg.querySelector("defs");

    if (defs) {
      defs.querySelector("#hero-land-clip")?.remove();

      const landClip = makeSvg("clipPath", { id: "hero-land-clip" });
      landClip.append(makeSvg("path", { d: landD }));
      defs.append(landClip);
    }

    const regionWashes = [
      { className: "hero-region-wash hero-region-wash--americas", center: [-66, 3], radius: 56 },
      { className: "hero-region-wash hero-region-wash--brazil", center: [-48, -19], radius: 18 },
      { className: "hero-region-wash hero-region-wash--usa", center: [-75, 37], radius: 13 },
      { className: "hero-region-wash hero-region-wash--europe", center: [8, 49], radius: 18 },
      { className: "hero-region-wash hero-region-wash--asia", center: [119, 30], radius: 29 }
    ];
    const washGroup = makeSvg("g", {
      class: "hero-region-washes",
      "clip-path": "url(#hero-land-clip)"
    });

    regionWashes.forEach((wash) => {
      const circle = d3.geoCircle()
        .center(wash.center)
        .radius(wash.radius)();
      const d = geoPath(circle);
      if (!d) return;
      washGroup.append(makeSvg("path", {
        class: wash.className,
        d
      }));
    });

    landGroup.replaceChildren(makeSvg("path", {
      class: "hero-land",
      d: landD
    }), washGroup);
    bordersGroup.replaceChildren(makeSvg("path", {
      class: "hero-country-border",
      d: geoPath(borders)
    }));
    routesGroup.replaceChildren();
    particlesGroup.replaceChildren();
    nodesGroup.replaceChildren();

    const coreCities = [
      { id: "sao-paulo", name: "Sao Paulo", coord: [-46.6333, -23.5505], tier: "origin", radius: 6.2 },
      { id: "rio", name: "Rio de Janeiro", coord: [-43.1729, -22.9068], tier: "secondary", radius: 2.5 },
      { id: "curitiba", name: "Curitiba", coord: [-49.2733, -25.4284], tier: "commerce", radius: 1.7 },
      { id: "porto-alegre", name: "Porto Alegre", coord: [-51.2177, -30.0346], tier: "commerce", radius: 1.7 },
      { id: "belo-horizonte", name: "Belo Horizonte", coord: [-43.9386, -19.9191], tier: "commerce", radius: 1.7 },
      { id: "brasilia", name: "Brasilia", coord: [-47.8825, -15.7942], tier: "commerce", radius: 1.7 },
      { id: "recife", name: "Recife", coord: [-34.877, -8.0476], tier: "commerce", radius: 1.6 },
      { id: "fortaleza", name: "Fortaleza", coord: [-38.5267, -3.7319], tier: "commerce", radius: 1.6 },
      { id: "salvador", name: "Salvador", coord: [-38.5014, -12.9777], tier: "commerce", radius: 1.5 },
      { id: "manaus", name: "Manaus", coord: [-60.0217, -3.119], tier: "commerce", radius: 1.4 },
      { id: "new-york", name: "New York", coord: [-74.006, 40.7128], tier: "usa", radius: 6.8 },
      { id: "miami", name: "Miami", coord: [-80.1918, 25.7617], tier: "secondary", radius: 2.7 },
      { id: "los-angeles", name: "Los Angeles", coord: [-118.2437, 34.0522], tier: "secondary", radius: 2.8 },
      { id: "san-francisco", name: "San Francisco", coord: [-122.4194, 37.7749], tier: "commerce", radius: 1.8 },
      { id: "chicago", name: "Chicago", coord: [-87.6298, 41.8781], tier: "secondary", radius: 2.4 },
      { id: "dallas", name: "Dallas", coord: [-96.797, 32.7767], tier: "commerce", radius: 1.9 },
      { id: "houston", name: "Houston", coord: [-95.3698, 29.7604], tier: "commerce", radius: 1.9 },
      { id: "seattle", name: "Seattle", coord: [-122.3321, 47.6062], tier: "commerce", radius: 1.8 },
      { id: "atlanta", name: "Atlanta", coord: [-84.388, 33.749], tier: "commerce", radius: 1.8 },
      { id: "boston", name: "Boston", coord: [-71.0589, 42.3601], tier: "commerce", radius: 1.7 },
      { id: "toronto", name: "Toronto", coord: [-79.3832, 43.6532], tier: "commerce", radius: 1.6 },
      { id: "mexico-city", name: "Mexico City", coord: [-99.1332, 19.4326], tier: "commerce", radius: 1.5 },
      { id: "london", name: "London", coord: [-0.1276, 51.5072], tier: "secondary", radius: 2.5 },
      { id: "paris", name: "Paris", coord: [2.3522, 48.8566], tier: "secondary", radius: 2.3 },
      { id: "amsterdam", name: "Amsterdam", coord: [4.9041, 52.3676], tier: "secondary", radius: 2.2 },
      { id: "frankfurt", name: "Frankfurt", coord: [8.6821, 50.1109], tier: "secondary", radius: 2.4 },
      { id: "madrid", name: "Madrid", coord: [-3.7038, 40.4168], tier: "commerce", radius: 1.8 },
      { id: "milan", name: "Milan", coord: [9.19, 45.4642], tier: "commerce", radius: 1.8 },
      { id: "berlin", name: "Berlin", coord: [13.405, 52.52], tier: "commerce", radius: 1.8 },
      { id: "lisbon", name: "Lisbon", coord: [-9.1393, 38.7223], tier: "commerce", radius: 1.7 },
      { id: "rotterdam", name: "Rotterdam", coord: [4.4777, 51.9244], tier: "commerce", radius: 1.4 },
      { id: "barcelona", name: "Barcelona", coord: [2.1734, 41.3851], tier: "commerce", radius: 1.4 },
      { id: "warsaw", name: "Warsaw", coord: [21.0122, 52.2297], tier: "commerce", radius: 1.4 },
      { id: "stockholm", name: "Stockholm", coord: [18.0686, 59.3293], tier: "commerce", radius: 1.4 },
      { id: "tokyo", name: "Tokyo", coord: [139.6917, 35.6895], tier: "secondary", radius: 2.6 },
      { id: "seoul", name: "Seoul", coord: [126.978, 37.5665], tier: "secondary", radius: 2.2 },
      { id: "shanghai", name: "Shanghai", coord: [121.4737, 31.2304], tier: "secondary", radius: 2.4 },
      { id: "hong-kong", name: "Hong Kong", coord: [114.1694, 22.3193], tier: "commerce", radius: 1.8 },
      { id: "singapore", name: "Singapore", coord: [103.8198, 1.3521], tier: "secondary", radius: 2.2 },
      { id: "osaka", name: "Osaka", coord: [135.5023, 34.6937], tier: "commerce", radius: 1.5 },
      { id: "taipei", name: "Taipei", coord: [121.5654, 25.033], tier: "commerce", radius: 1.5 },
      { id: "shenzhen", name: "Shenzhen", coord: [114.0579, 22.5431], tier: "commerce", radius: 1.4 },
      { id: "bangkok", name: "Bangkok", coord: [100.5018, 13.7563], tier: "commerce", radius: 1.4 },
      { id: "dubai", name: "Dubai", coord: [55.2708, 25.2048], tier: "commerce", radius: 1.6 },
      { id: "mumbai", name: "Mumbai", coord: [72.8777, 19.076], tier: "commerce", radius: 1.4 }
    ];

    const clusterSeeds = [
      {
        prefix: "ny",
        center: [-74.006, 40.7128],
        radius: 1.05,
        points: [[0.35, 0.18], [-0.42, -0.12], [0.12, 0.48], [-0.16, -0.42], [0.72, -0.28], [-0.68, 0.3], [0.54, 0.64], [-0.84, -0.5]]
      },
      {
        prefix: "us-ne",
        center: [-76.4, 39.4],
        radius: 1.05,
        points: [[-1.1, 0.1], [0.9, 0.7], [1.5, -0.25], [-0.4, -1.0], [2.1, 1.3], [-1.8, 1.1], [0.25, 1.8], [1.2, -1.55]]
      },
      {
        prefix: "california",
        center: [-119.4, 36.6],
        radius: 1.05,
        points: [[-1.2, 1.4], [1.0, -1.2], [-0.4, -2.4], [1.8, 0.9], [-2.1, -0.2], [0.2, 2.2]]
      },
      {
        prefix: "texas",
        center: [-97.8, 31.2],
        radius: 1.05,
        points: [[-1.0, 1.6], [1.2, -1.1], [2.0, 0.2], [-2.1, -0.8], [0.2, 2.5], [1.7, 1.7]]
      },
      {
        prefix: "southeast-us",
        center: [-84.0, 32.5],
        radius: 1,
        points: [[-1.4, 0.2], [1.2, -0.8], [0.2, 1.4], [1.8, 1.1], [-2.2, -1.1], [2.5, -1.7]]
      },
      {
        prefix: "sp",
        center: [-46.6333, -23.5505],
        radius: 1.05,
        points: [[0.42, 0.2], [-0.5, -0.16], [0.18, 0.62], [-0.2, -0.58], [0.78, -0.34], [-0.92, 0.36], [1.12, 0.5], [-1.2, -0.48]]
      },
      {
        prefix: "brazil-se",
        center: [-44.3, -21.3],
        radius: 1,
        points: [[-1.2, 0.8], [1.1, -0.7], [2.1, 0.4], [-2.0, -1.1], [0.2, 1.7], [1.7, 1.5], [-2.4, 0.6]]
      },
      {
        prefix: "brazil-south",
        center: [-50.3, -27.4],
        radius: 0.95,
        points: [[-0.9, 0.8], [1.0, -0.7], [1.8, 0.2], [-1.6, -1.0], [0.2, 1.5]]
      },
      {
        prefix: "brazil-northeast",
        center: [-37.5, -7.4],
        radius: 0.9,
        points: [[-1.4, 0.7], [1.2, -0.4], [2.0, 0.8], [-2.2, -0.9], [0.1, 1.4]]
      },
      {
        prefix: "europe-west",
        center: [2.0, 49.0],
        radius: 0.88,
        points: [[-1.8, 1.2], [1.7, -0.9], [3.0, 0.4], [-3.1, -1.0], [0.3, 1.9], [2.4, 1.6], [-2.2, 2.4], [4.0, -1.9], [-4.2, 0.6], [1.0, -2.4]]
      },
      {
        prefix: "europe-south",
        center: [8.0, 43.0],
        radius: 0.82,
        points: [[-2.0, 1.0], [1.8, -0.7], [3.4, 0.3], [-3.3, -1.0], [0.4, 1.8], [2.4, 1.3], [-1.2, -2.1]]
      },
      {
        prefix: "asia-east",
        center: [123.4, 31.5],
        radius: 0.9,
        points: [[-2.2, 0.8], [2.0, -0.7], [3.6, 0.4], [-3.8, -1.2], [0.3, 1.8], [2.8, 1.6], [-1.2, -2.4], [4.8, -1.8]]
      },
      {
        prefix: "japan-korea",
        center: [133.0, 36.2],
        radius: 0.82,
        points: [[-2.0, 0.6], [1.8, -0.5], [3.0, 0.7], [-3.2, -1.0], [0.4, 1.6], [2.2, 1.4]]
      },
      {
        prefix: "sea",
        center: [104.0, 8.5],
        radius: 0.82,
        points: [[-2.0, 1.0], [1.8, -0.8], [3.2, 0.3], [-3.4, -1.1], [0.2, 1.9], [2.5, 1.5]]
      }
    ];

    const regionFromCoord = ([lng, lat]) => {
      if (lng <= -30 && lng >= -128) return "americas";
      if (lng >= -12 && lng <= 34 && lat >= 35) return "europe";
      if (lng >= 50 && lng <= 150) return "asia";
      return "neutral";
    };

    const clusterCities = clusterSeeds.flatMap((cluster) =>
      cluster.points.map(([lngOffset, latOffset], index) => ({
        id: `${cluster.prefix}-micro-${index + 1}`,
        name: `${cluster.prefix} micro ${index + 1}`,
        coord: [cluster.center[0] + lngOffset, cluster.center[1] + latOffset],
        tier: "micro",
        radius: cluster.radius
      }))
    );

    const cityList = [...coreCities, ...clusterCities].map((city) => ({
      ...city,
      region: city.region || regionFromCoord(city.coord)
    }));

    const cities = new Map(cityList.map((city) => [city.id, { ...city, point: projection(city.coord) }]));
    const projected = (id) => cities.get(id)?.point;
    const arcPath = (fromId, toId, curve = 0.18, fromOffset = [0, 0], toOffset = [0, 0], controlOffset = [0, 0]) => {
      const startPoint = projected(fromId);
      const endPoint = projected(toId);
      if (!startPoint || !endPoint) return "";

      const start = [startPoint[0] + fromOffset[0], startPoint[1] + fromOffset[1]];
      const end = [endPoint[0] + toOffset[0], endPoint[1] + toOffset[1]];
      if (!start || !end) return "";

      const [x1, y1] = start;
      const [x2, y2] = end;
      const distance = Math.hypot(x2 - x1, y2 - y1);
      const lift = Math.min(190, Math.max(34, distance * curve));
      const controlX = (x1 + x2) / 2 + controlOffset[0];
      const controlY = Math.min(y1, y2) - lift + controlOffset[1];

      return `M${x1.toFixed(1)} ${y1.toFixed(1)} Q${controlX.toFixed(1)} ${controlY.toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
    };

    const routeDefs = [
      { id: "route-br-us", from: "sao-paulo", to: "new-york", modifier: "primary", curve: 0.14, toOffset: [-2, 3], controlOffset: [-170, 80] },
      { id: "route-us-london", from: "new-york", to: "london", modifier: "secondary", curve: 0.13, fromOffset: [4, -3] },
      { id: "route-us-paris", from: "new-york", to: "paris", modifier: "secondary", curve: 0.12, fromOffset: [-3, 2] },
      { id: "route-us-frankfurt", from: "new-york", to: "frankfurt", modifier: "secondary", curve: 0.12, fromOffset: [6, 2] },
      { id: "route-us-amsterdam", from: "new-york", to: "amsterdam", modifier: "secondary", curve: 0.13, fromOffset: [-5, -2] },
      { id: "route-us-tokyo", from: "new-york", to: "tokyo", modifier: "secondary", curve: 0.13, fromOffset: [3, 5] },
      { id: "route-us-shanghai", from: "new-york", to: "shanghai", modifier: "secondary", curve: 0.12, fromOffset: [-6, 4] },
      { id: "route-us-singapore", from: "new-york", to: "singapore", modifier: "secondary", curve: 0.11, fromOffset: [5, -5] },
      { id: "route-us-madrid", from: "new-york", to: "madrid", modifier: "tertiary", curve: 0.1, fromOffset: [-4, 5] },
      { id: "route-us-seoul", from: "new-york", to: "seoul", modifier: "tertiary", curve: 0.12, fromOffset: [6, -1] },
      { id: "route-us-la", from: "new-york", to: "los-angeles", modifier: "regional", curve: 0.08, fromOffset: [-4, 0] },
      { id: "route-us-miami", from: "new-york", to: "miami", modifier: "regional", curve: 0.07, fromOffset: [3, 2] },
      { id: "route-us-chicago", from: "new-york", to: "chicago", modifier: "regional", curve: 0.07, fromOffset: [-2, -4] },
      { id: "route-us-dallas", from: "new-york", to: "dallas", modifier: "regional", curve: 0.07, fromOffset: [5, 3] },
      { id: "route-br-rio", from: "sao-paulo", to: "rio", modifier: "regional", curve: 0.06 },
      { id: "route-br-curitiba", from: "sao-paulo", to: "curitiba", modifier: "regional", curve: 0.05 },
      { id: "route-br-brasilia", from: "sao-paulo", to: "brasilia", modifier: "regional", curve: 0.06 },
      { id: "route-br-recife", from: "sao-paulo", to: "recife", modifier: "regional", curve: 0.07 },
      { id: "route-eu-london-paris", from: "london", to: "paris", modifier: "regional", curve: 0.05 },
      { id: "route-eu-paris-frankfurt", from: "paris", to: "frankfurt", modifier: "regional", curve: 0.05 },
      { id: "route-eu-amsterdam-frankfurt", from: "amsterdam", to: "frankfurt", modifier: "regional", curve: 0.05 },
      { id: "route-eu-paris-madrid", from: "paris", to: "madrid", modifier: "quiet", curve: 0.06 },
      { id: "route-asia-shanghai-hk", from: "shanghai", to: "hong-kong", modifier: "regional", curve: 0.05 },
      { id: "route-asia-shanghai-seoul", from: "shanghai", to: "seoul", modifier: "regional", curve: 0.06 },
      { id: "route-asia-seoul-tokyo", from: "seoul", to: "tokyo", modifier: "regional", curve: 0.05 },
      { id: "route-br-lisbon", from: "sao-paulo", to: "lisbon", modifier: "quiet", curve: 0.1 },
      { id: "route-br-frankfurt", from: "sao-paulo", to: "frankfurt", modifier: "quiet", curve: 0.11 },
      { id: "route-br-london", from: "sao-paulo", to: "london", modifier: "quiet", curve: 0.1 },
      { id: "route-frankfurt-tokyo", from: "frankfurt", to: "tokyo", modifier: "quiet", curve: 0.1 },
      { id: "route-amsterdam-shanghai", from: "amsterdam", to: "shanghai", modifier: "quiet", curve: 0.09 },
      { id: "route-paris-singapore", from: "paris", to: "singapore", modifier: "quiet", curve: 0.08 }
    ];

    const routeTone = (route) => {
      const fromRegion = cities.get(route.from)?.region;
      const toRegion = cities.get(route.to)?.region;

      if (fromRegion === "americas" && toRegion === "americas") return "americas";
      if (fromRegion === "americas" && toRegion === "europe") return "atlantic";
      if (fromRegion === "europe" && toRegion === "europe") return "europe";
      if (toRegion === "asia" || fromRegion === "asia") return "asia";
      return "global";
    };

    routeDefs.forEach((route) => {
      const d = arcPath(route.from, route.to, route.curve, route.fromOffset, route.toOffset, route.controlOffset);
      if (!d) return;
      routesGroup.append(makeSvg("path", {
        id: route.id,
        class: `hero-route hero-route--${route.modifier} hero-route--tone-${route.tone || routeTone(route)}`,
        d
      }));
    });

    [
      { className: "hero-particle hero-particle--primary", pathId: "route-br-us", radius: 3.8 },
      { className: "hero-particle", pathId: "route-us-london", radius: 2.5 },
      { className: "hero-particle hero-particle--soft", pathId: "route-us-tokyo", radius: 2.4 },
      { className: "hero-particle hero-particle--soft", pathId: "route-br-frankfurt", radius: 2.2 }
    ].forEach((particle) => {
      const route = hero.querySelector(`#${particle.pathId}`);
      if (!route) return;
      const start = route.getPointAtLength(0);
      particlesGroup.append(makeSvg("circle", {
        class: particle.className,
        "data-motion-path": `#${particle.pathId}`,
        r: particle.radius,
        cx: start.x,
        cy: start.y
      }));
    });

    cityList.forEach((city) => {
      const point = projected(city.id);
      if (!point) return;
      const [cx, cy] = point;

      if (city.tier === "origin" || city.tier === "usa") {
        nodesGroup.append(makeSvg("circle", {
          class: "hero-node-ring",
          cx,
          cy,
          r: city.radius + 6
        }));
        nodesGroup.append(makeSvg("circle", {
          class: "hero-node-pulse",
          cx,
          cy,
          r: city.radius + 12
        }));
      }

      const className = [
        "hero-node",
        city.tier === "origin" ? "hero-node--origin hero-node--hub" : "",
        city.tier === "usa" ? "hero-node--usa hero-node--hub" : "",
        city.tier === "secondary" ? "hero-node--secondary" : "",
        city.tier === "commerce" ? "hero-node--commerce" : "",
        city.tier === "micro" ? "hero-node--micro" : "",
        city.region ? `hero-node--region-${city.region}` : ""
      ].filter(Boolean).join(" ");

      nodesGroup.append(makeSvg("circle", {
        class: className,
        cx,
        cy,
        r: city.radius
      }));
    });

    document.documentElement.dataset.heroMap = "world-atlas";
  }

  async function initHero() {
    const hero = document.querySelector(".hero");
    if (!hero) return;

    document.documentElement.dataset.heroMotion = "video";

    gsap.set(".hero-video", { scale: 1.035, transformOrigin: "center" });
    gsap.set(".hero-scroll", { autoAlpha: 0, y: 12 });
    gsap.to(".hero-video", { scale: 1, duration: 1.8, ease: "power2.out" });
    gsap.to(".hero-scroll", { autoAlpha: 1, y: 0, duration: 0.5, delay: 0.45, ease: "power3.out" });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: hero,
          start: "top top",
          end: "bottom top",
          scrub: 1
        }
      })
      .to(".hero-video", { yPercent: -2.2, scale: 1.045, ease: "none" }, 0)
      .to(".hero-video-vignette", { opacity: 0.72, ease: "none" }, 0);

    return;

    await buildHeroWorldNetwork(hero);

    document.documentElement.dataset.heroMotion = hasMotionPath ? "motion-path" : "gsap";
    document.documentElement.dataset.heroInitCount = String(
      (Number(document.documentElement.dataset.heroInitCount) || 0) + 1
    );

    const routes = gsap.utils.toArray(".hero-route");
    const primaryRoute = document.querySelector("#route-br-us");
    const secondaryRoutes = routes.filter((route) => route !== primaryRoute);
    const particles = [
      { target: ".hero-particle--primary", path: "#route-br-us", duration: 3.8, delay: 1.9 },
      { target: ".hero-particles .hero-particle:nth-child(2)", path: "#route-us-london", duration: 5.2, delay: 2.35 },
      { target: ".hero-particles .hero-particle:nth-child(3)", path: "#route-us-tokyo", duration: 7.4, delay: 2.75 },
      { target: ".hero-particles .hero-particle:nth-child(4)", path: "#route-br-frankfurt", duration: 6.1, delay: 3.15 }
    ].filter(({ target, path }) => document.querySelector(target) && document.querySelector(path));

    routes.forEach((route) => {
      const length = route.getTotalLength();
      route.dataset.pathLength = length;
      gsap.set(route, {
        strokeDasharray: length,
        strokeDashoffset: length
      });
    });

    gsap.set(".hero-bg", { scale: 1.04, transformOrigin: "center" });
    gsap.set(".hero-map", { autoAlpha: 0, scale: 0.985, transformOrigin: "center" });
    gsap.set(".hero-node", { autoAlpha: 0, scale: 0.45, transformOrigin: "center" });
    gsap.set(".hero-node-ring, .hero-node-pulse", { autoAlpha: 0, scale: 0.88, transformOrigin: "center" });
    gsap.set(".hero-particle", { autoAlpha: 0 });
    gsap.set(".hero-title", { scale: 1.06, transformOrigin: "center" });
    gsap.set(".hero-logo", { y: 78, scale: 0.96, transformOrigin: "center bottom" });
    gsap.set(".hero-logo-mask", { clipPath: "inset(100% 0 0 0)" });
    gsap.set(".hero-full-commerce", { autoAlpha: 0, y: 30 });
    gsap.set(".hero-subtitle", { autoAlpha: 0, y: 15 });
    const heroCapabilityItems = gsap.utils.toArray(".hero-capabilities div");
    if (heroCapabilityItems.length) {
      gsap.set(heroCapabilityItems, { autoAlpha: 0, y: 18 });
    }
    gsap.set(".hero-editorial", { autoAlpha: 0, y: 18 });
    gsap.set(".hero-brandline", { autoAlpha: 0, y: 12 });
    gsap.set(".hero-scroll", { autoAlpha: 0, y: 12 });

    gsap.to(".hero-blob-1", {
      xPercent: 12,
      yPercent: -8,
      rotation: 20,
      scale: 1.12,
      duration: 18,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    gsap.to(".hero-blob-2", {
      xPercent: -10,
      yPercent: 10,
      rotation: -15,
      scale: 0.92,
      duration: 22,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    gsap.to(".hero-blob-3", {
      xPercent: -8,
      yPercent: -12,
      rotation: 16,
      scale: 1.08,
      duration: 27,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    gsap.to(".hero-ambient-orange", {
      xPercent: 8,
      yPercent: -5,
      duration: 12,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    gsap.to(".hero-ambient-blue", {
      xPercent: -6,
      yPercent: 5,
      duration: 16,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    gsap.to(".hero-node--hub", {
      scale: 1.16,
      opacity: 0.72,
      duration: 2.35,
      delay: 2.35,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      stagger: 0.22
    });

    gsap.to(".hero-node-pulse", {
      scale: 1.8,
      opacity: 0,
      duration: 3.1,
      delay: 2.55,
      repeat: -1,
      ease: "sine.out",
      stagger: 0.42
    });

    if (hasMotionPath) {
      particles.forEach(({ target, path, duration, delay }, index) => {
        gsap.to(target, {
          autoAlpha: index === 0 ? 0.96 : 0.72,
          duration: 0.4,
          delay
        });

        gsap.to(target, {
          duration,
          delay,
          repeat: -1,
          ease: "none",
          motionPath: {
            path,
            align: path,
            alignOrigin: [0.5, 0.5],
            autoRotate: false
          }
        });
      });
    }

    const parallaxItems = [
      { target: ".hero-world", depth: 5 },
      { target: ".hero-routes", depth: 8 },
      { target: ".hero-ambient-orange", depth: 10 },
      { target: ".hero-ambient-blue", depth: -9 },
      { target: ".hero-blob-1", depth: 7 },
      { target: ".hero-blob-2", depth: -7 },
      { target: ".hero-blob-3", depth: 5 },
      { target: ".hero-editorial--left", depth: 4 },
      { target: ".hero-editorial--right", depth: -4 },
      { target: ".hero-brandline", depth: -3 },
      { target: ".hero-title", depth: 2 }
    ].filter(({ target }) => document.querySelector(target));

    const parallaxSetters = parallaxItems.map(({ target, depth }) => ({
      depth,
      x: gsap.quickTo(target, "x", { duration: 1.4, ease: "power3.out" }),
      y: gsap.quickTo(target, "y", { duration: 1.4, ease: "power3.out" })
    }));

    if (window.matchMedia("(pointer: fine)").matches) {
      window.addEventListener("pointermove", (event) => {
        const x = (event.clientX / window.innerWidth - 0.5) * 2;
        const y = (event.clientY / window.innerHeight - 0.5) * 2;

        parallaxSetters.forEach((item) => {
          item.x(x * item.depth);
          item.y(y * item.depth * 0.72);
        });
      }, { passive: true });
    }

    const playHeroIntroOnce = () => {
      if (hero.dataset.introPlayed === "true") return;
      hero.dataset.introPlayed = "true";
      heroIntro.play(0);
    };

    const heroIntro = gsap
      .timeline({ paused: true })
      .to(".hero-bg", { scale: 1, duration: 1.8, ease: "power2.out" }, 0)
      .to(".hero-map", { autoAlpha: 1, scale: 1, duration: 1.15, ease: "power2.out" }, 0.05)
      .to(primaryRoute, { strokeDashoffset: 0, duration: 1.55, ease: "power2.out" }, 0.14)
      .to(".hero-editorial", { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.09 }, 0.46)
      .to(".hero-brandline", { autoAlpha: 1, y: 0, duration: 0.48 }, 0.54)
      .to(".hero-subtitle", { autoAlpha: 1, y: 0, duration: 0.54 }, 0.72)
      .to(".hero-logo-mask", { clipPath: "inset(0% 0 0 0)", duration: 1.15, ease: "power4.out" }, 0.96)
      .to(".hero-logo", { y: 0, scale: 1, duration: 1.15, ease: "power4.out" }, 0.96)
      .to(".hero-title", { scale: 1, duration: 1.25, ease: "power3.out" }, 0.96)
      .to(".hero-full-commerce", { autoAlpha: 1, y: 0, duration: 0.7, ease: "power3.out" }, 1.52)
      .to(secondaryRoutes, { strokeDashoffset: 0, duration: 1.55, stagger: 0.045, ease: "power2.out" }, 1.7)
      .to(".hero-node-ring, .hero-node-pulse", { autoAlpha: 1, scale: 1, duration: 0.56, stagger: 0.05 }, 1.84)
      .to(".hero-node", { autoAlpha: 1, scale: 1, duration: 0.48, stagger: 0.055, ease: "power2.out" }, 1.88);

    if (heroCapabilityItems.length) {
      heroIntro.to(heroCapabilityItems, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.07 }, 2.08);
    }

    heroIntro.to(".hero-scroll", { autoAlpha: 1, y: 0, duration: 0.5 }, 2.32);

    ScrollTrigger.create({
      trigger: hero,
      start: "top bottom",
      end: "bottom top",
      once: true,
      onEnter: playHeroIntroOnce,
      onEnterBack: playHeroIntroOnce
    });

    const heroRect = hero.getBoundingClientRect();
    if (heroRect.top < window.innerHeight && heroRect.bottom > 0) {
      playHeroIntroOnce();
    }

    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".hero",
          start: "top top",
          end: "bottom top",
          scrub: 1
        }
      })
      .to(".hero-bg", { yPercent: -2, scale: 1.06, ease: "none" }, 0)
      .to(".hero-world", { yPercent: -5, scale: 1.03, ease: "none" }, 0);
  }

  function initExpansion() {
    const stats = gsap.utils.toArray(".takeover-stat");
    gsap.set(".expansion-copy", { autoAlpha: 0, xPercent: 18, scale: 0.96, filter: "blur(8px)" });
    gsap.set(".warehouse-scene", {
      autoAlpha: 0,
      clipPath: "inset(100% 0 0 0)",
      filter: "brightness(0.68)"
    });
    gsap.set(".warehouse-photo", { scale: 1.06, yPercent: -2 });
    gsap.set(".warehouse-light", { xPercent: -4, opacity: 0.3 });
    gsap.set(".warehouse-bridge", { autoAlpha: 0 });
    gsap.set(".warehouse-transition-panel", { autoAlpha: 0, yPercent: 100 });
    gsap.set(".orlando-scene", { autoAlpha: 0, clipPath: "circle(0% at 27% 58%)" });
    gsap.set(".orlando-photo", { scale: 1.08, yPercent: -2 });
    gsap.set(".location-marker", { autoAlpha: 0, scale: 0.2 });
    gsap.set(".location-stat", { autoAlpha: 0 });
    gsap.set(".location-label", { autoAlpha: 0, y: 20 });
    gsap.set(".location-stat strong span", { yPercent: 112 });
    gsap.set(".location-stat em", { autoAlpha: 0, yPercent: 110 });
    gsap.set(stats, { autoAlpha: 0, y: 80, scale: 0.9 });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".expansion",
          start: "top top",
          end: "+=240%",
          pin: ".expansion .pin-stage",
          scrub: 0.65,
          anticipatePin: 1
        }
      })
      .from(".expansion h2 span", { yPercent: 110, opacity: 0, stagger: 0.08 })
      .to({}, { duration: 0.6 })
      .to(".expansion-date", {
        xPercent: -28,
        scale: 0.88,
        autoAlpha: 0,
        letterSpacing: "0.05em",
        filter: "blur(8px)",
        transformOrigin: "left center",
        duration: 1,
        ease: "power2.inOut"
      })
      .to(".expansion-copy", {
        autoAlpha: 1,
        xPercent: 0,
        scale: 1,
        filter: "blur(0px)",
        duration: 1
      }, "-=0.55")
      .to({}, { duration: 0.7 })
      .to(".expansion-copy", { autoAlpha: 0, yPercent: -10, scale: 0.92, filter: "blur(6px)", ease: "none" })
      .addLabel("warehouseEnter")
      .to(".warehouse-scene", {
        autoAlpha: 1,
        clipPath: "inset(0% 0 0 0)",
        filter: "brightness(0.8)",
        duration: 0.8,
        ease: "power2.inOut"
      }, "warehouseEnter+=0.12")
      .to(".warehouse-photo", { scale: 1.03, yPercent: 1, duration: 3.6, ease: "none" }, "warehouseEnter+=0.12")
      .to(".warehouse-light", { xPercent: 5, opacity: 0.48, duration: 3.6, ease: "none" }, "warehouseEnter+=0.12")
      .to(stats[0], { autoAlpha: 1, y: 0, scale: 1, duration: 0.65 }, "warehouseEnter+=0.28")
      .to({}, { duration: 0.45 })
      .to(stats[0], { autoAlpha: 0, y: -80, scale: 1.04, duration: 0.75, ease: "power2.in" })
      .to(stats[1], { autoAlpha: 1, y: 0, scale: 1, duration: 0.7 })
      .to({}, { duration: 0.45 })
      .to(stats[1], { autoAlpha: 0, y: -80, scale: 1.04, duration: 0.75, ease: "power2.in" })
      .to(".warehouse-photo", { scale: 1.06, filter: "brightness(0.74)", duration: 0.9, ease: "none" }, "<")
      .to(".location-marker", { autoAlpha: 1, scale: 1, duration: 0.42, ease: "back.out(1.8)" }, "-=0.25")
      .to(".location-marker", { scale: 30, duration: 1.15, ease: "power3.inOut" })
      .to(".orlando-scene", {
        autoAlpha: 1,
        clipPath: "circle(145% at 27% 58%)",
        duration: 1.15,
        ease: "power3.inOut"
      }, "<")
      .to(".orlando-photo", { scale: 1, yPercent: 0, duration: 2.7, ease: "none" }, "<")
      .to(".location-marker", { autoAlpha: 0, duration: 0.12 })
      .to(".location-stat", { autoAlpha: 1, duration: 0.1 })
      .to(".location-label", { autoAlpha: 1, y: 0, duration: 0.38 })
      .to(".location-stat strong span", { yPercent: 0, stagger: 0.08, duration: 0.78, ease: "power3.out" }, "-=0.14")
      .to(".location-stat em", { autoAlpha: 1, yPercent: 0, duration: 0.48, ease: "power3.out" }, "-=0.36")
      .to({}, { duration: 0.55 })
      .to(".orlando-photo", { scale: 1.035, duration: 1.1, ease: "none" })
      .to(".warehouse-bridge", { autoAlpha: 1, duration: 0.9, ease: "power2.inOut" }, "-=0.65")
      .to(".location-stat", { autoAlpha: 0, yPercent: -8, duration: 0.6, ease: "power2.in" }, "<0.18");
  }

  function initEcosystem() {
    const section = document.querySelector(".ecosystem");
    if (!section) return;

    ecosystemCleanup();
    ecosystemCleanup = () => {};

    if (ecosystemContext) {
      ecosystemContext.revert();
      gsap.set(
        section.querySelectorAll(
          ".service-node, .ecosystem-emblem, .ecosystem-center-glow, .ecosystem-logo, .ecosystem-title, .ecosystem-link"
        ),
        { clearProps: "all" }
      );
    }

    ecosystemContext = gsap.context(buildEcosystem, section);
  }

  function buildEcosystem() {
    const section = document.querySelector(".ecosystem");
    if (!section) return;

    const seal = section.querySelector(".ecosystem-emblem");
    const centerGlow = section.querySelector(".ecosystem-center-glow");
    const logo = section.querySelector(".ecosystem-logo");
    const title = section.querySelector(".ecosystem-title");
    const serviceOrder = ["consultoria", "marketing", "exportacao", "fulfillment", "suporte", "implantacao"];
    const nodes = serviceOrder
      .map((service) => section.querySelector(`.service-node[data-service="${service}"]`))
      .filter(Boolean);
    const links = serviceOrder
      .map((service) => section.querySelector(`.ecosystem-link[data-service="${service}"]`))
      .filter(Boolean);
    const drawTargets = gsap.utils.toArray(section.querySelectorAll(".ecosystem-draw"));
    const network = section.querySelector(".ecosystem-network");
    const map = section.querySelector(".ecosystem-map");
    const desktopPaths = {
      consultoria: "M500 350 C438 286 360 210 268 171",
      marketing: "M500 350 C562 286 640 210 732 171",
      exportacao: "M500 350 C626 330 724 338 860 350",
      fulfillment: "M500 350 C562 426 638 506 730 529",
      suporte: "M500 350 C438 426 362 506 270 529",
      implantacao: "M500 350 C374 330 276 338 140 350"
    };
    const applyResponsivePaths = () => {
      const isMobile = window.matchMedia("(max-width: 1023px), (hover: none) and (pointer: coarse)").matches;

      network.setAttribute("preserveAspectRatio", isMobile ? "none" : "xMidYMid meet");

      links.forEach((path) => {
        const service = path.dataset.service;
        if (!service) return;
        path.setAttribute(
          "d",
          isMobile && map
            ? getEcosystemCompactPath(section, network, map, service, desktopPaths)
            : getEcosystemServicePath(section, network, service, desktopPaths)
        );
      });
    };
    const syncDrawMetrics = ({ reset = false } = {}) => {
      applyResponsivePaths();

      drawTargets.forEach((path) => {
        const length = path.getTotalLength();
        const currentOffset = Number(gsap.getProperty(path, "strokeDashoffset")) || 0;
        const isAlreadyDrawn = !reset && currentOffset < length * 0.5;

        gsap.set(path, {
          strokeDasharray: length,
          strokeDashoffset: isAlreadyDrawn ? 0 : length,
          autoAlpha: isAlreadyDrawn ? 0.82 : 0
        });
      });
    };

    gsap.set(centerGlow, { autoAlpha: 0, scale: 0.85, transformOrigin: "center" });
    gsap.set(seal, { autoAlpha: 0, scale: 0.85, transformOrigin: "center" });
    gsap.set(logo, { autoAlpha: 0, y: 10, scale: 0.96, transformOrigin: "center" });
    gsap.set(title, { autoAlpha: 0, y: 18 });
    gsap.set(nodes, {
      autoAlpha: 0,
      y: 12,
      scale: 0.96,
      "--service-icon": "rgba(58, 9, 3, 0.54)",
      "--service-label": "rgba(58, 9, 3, 0.68)",
      "--service-glow": 0.08,
      transformOrigin: "center"
    });

    syncDrawMetrics({ reset: true });

    const calmNode = {
      "--service-icon": "rgba(58, 9, 3, 0.56)",
      "--service-label": "rgba(58, 9, 3, 0.68)",
      "--service-glow": 0.1,
      duration: 0.24,
      ease: "power2.out"
    };
    const activeNode = {
      "--service-icon": "#f0440b",
      "--service-label": "#3a0903",
      "--service-glow": 0.72,
      duration: 0.28,
      ease: "power2.out"
    };
    const calmLink = {
      stroke: "rgba(137, 94, 74, 0.46)",
      strokeOpacity: 0.44,
      autoAlpha: 0.72,
      duration: 0.24,
      ease: "power2.out"
    };
    const activeLink = {
      stroke: "#f0440b",
      strokeOpacity: 0.58,
      autoAlpha: 1,
      duration: 0.42,
      ease: "power2.inOut"
    };

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        id: "ecosystem",
        start: "top 78%",
        end: "center center",
        scrub: 0.25,
        invalidateOnRefresh: true,
        onRefresh: () => syncDrawMetrics(),
        onUpdate: () => applyResponsivePaths()
      }
    });

    tl
      .to(centerGlow, { autoAlpha: 1, scale: 1, duration: 0.7, ease: "power2.out" })
      .to(seal, { autoAlpha: 0.08, scale: 1, duration: 0.7, ease: "power2.out" }, "<")
      .to(logo, { autoAlpha: 1, y: 0, scale: 1, duration: 0.54, ease: "power3.out" }, ">-0.16")
      .to(title, { autoAlpha: 1, y: 0, duration: 0.42, ease: "power2.out" }, ">-0.16")
      .to({}, { duration: 0.2 });

    serviceOrder.forEach((service, index) => {
      const node = nodes[index];
      const link = links[index];
      const previousNodes = nodes.slice(0, index);
      const previousLinks = links.slice(0, index);
      if (!node || !link) return;

      tl.addLabel(`ecosystem-${service}`);

      if (previousNodes.length) {
        tl
          .to(previousNodes, calmNode, ">")
          .to(previousLinks, calmLink, "<")
          .to(link, { strokeDashoffset: 0, ...activeLink }, "<0.05");
      } else {
        tl.to(link, { strokeDashoffset: 0, ...activeLink }, ">");
      }

      tl
        .to(node, { autoAlpha: 1, y: 0, scale: 1, duration: 0.36, ease: "power3.out" }, "<0.08")
        .to(node, activeNode, "<")
        .to({}, { duration: 0.18 });
    });

    tl
      .to(nodes, {
        autoAlpha: 0.94,
        scale: 1,
        "--service-icon": "rgba(240, 68, 11, 0.76)",
        "--service-label": "#3a0903",
        "--service-glow": 0.22,
        duration: 0.56,
        ease: "power2.inOut"
      })
      .to(links, {
        stroke: "#f0440b",
        strokeOpacity: 0.28,
        autoAlpha: 0.82,
        duration: 0.56,
        ease: "power2.inOut"
      }, "<")
      .to(centerGlow, { scale: 1.06, autoAlpha: 1, duration: 0.56, ease: "power2.inOut" }, "<")
      .to(logo, { scale: 1.015, duration: 0.56, ease: "power2.inOut" }, "<")
      .to({}, { duration: 0.6 });

    let pathRefreshTimer;
    const refreshResponsivePaths = () => {
      window.clearTimeout(pathRefreshTimer);
      pathRefreshTimer = window.setTimeout(() => {
        ScrollTrigger.refresh();
        syncDrawMetrics();
        ScrollTrigger.update();
      }, 120);
    };

    window.addEventListener("resize", refreshResponsivePaths, { passive: true });
    document.fonts?.ready.then(refreshResponsivePaths);
    let pathObserver;
    if ("ResizeObserver" in window) {
      pathObserver = new ResizeObserver(refreshResponsivePaths);
      pathObserver.observe(section);
      if (network) pathObserver.observe(network);
    }

    ecosystemCleanup = () => {
      window.clearTimeout(pathRefreshTimer);
      window.removeEventListener("resize", refreshResponsivePaths);
      if (pathObserver) pathObserver.disconnect();
    };

    refreshResponsivePaths();
  }

  function initOkBreak() {
    const section = document.querySelector(".ok-break");
    if (!section) return;

    okBreakCleanup();
    okBreakCleanup = () => {};
    okBreakBreakpointCleanup();
    okBreakBreakpointCleanup = () => {};
    syncOkBreakScrollState = () => {};

    if (okBreakContext) {
      okBreakContext.revert();
    }

    okBreakContext = gsap.context(() => {
      const stage = section.querySelector(".ok-break__stage");
      const intro = section.querySelector(".ok-break__intro");
      const question = section.querySelector(".ok-break__question");
      const ok = section.querySelector(".ok-break__ok");
      const phrase = section.querySelector(".ok-break__phrase");
      const grande = section.querySelector(".ok-break__grande");
      const mas = section.querySelector(".ok-break__side--mas");
      const quanto = section.querySelector(".ok-break__side--quanto");
      const details = section.querySelector(".ok-break__details");

      if (!stage || !intro || !question || !ok || !phrase || !grande || !mas || !quanto || !details) return;

      const getGrandeScale = () => {
        const width = window.innerWidth;
        if (width < 560) return 2.15;
        if (width < 900) return 3.2;
        return 4.85;
      };
      const getGrandePush = () => {
        const scale = getGrandeScale();
        const wordWidth = grande.getBoundingClientRect().width || 1;
        const viewportLimit = window.innerWidth * (isCompactViewport() ? 0.18 : 0.36);
        return Math.min(viewportLimit, wordWidth * (scale - 1) * 0.52);
      };
      const getPhraseLift = () => {
        const okHeight = ok.getBoundingClientRect().height || 0;
        return -(okHeight * 0.42);
      };
      const getExitLift = () =>
        window.innerWidth < 760 ? getPhraseLift() : getPhraseLift() - window.innerHeight * 0.2;
      const isCompactViewport = () => window.innerWidth < 760;
      const isCompact = isCompactViewport();
      const timing = isCompact
        ? {
            introOut: 1.45,
            okIn: 1.53,
            phraseIn: 1.76,
            okOut: 2.18,
            phraseLift: 2.17,
            expand: 2.46,
            phraseExit: 3.26,
            hold: 0.14
          }
        : {
            introOut: 2.12,
            okIn: 2.2,
            phraseIn: 2.55,
            okOut: 3.24,
            phraseLift: 3.2,
            expand: 3.58,
            phraseExit: 4.98,
            hold: 0.2
          };

      gsap.set(intro, {
        autoAlpha: isCompact ? 1 : 0,
        y: isCompact ? 0 : 42,
        scale: 1,
        filter: isCompact ? "blur(0px)" : "blur(12px)"
      });
      gsap.set(question, { autoAlpha: 1 });
      gsap.set(ok, { autoAlpha: 0, y: 60, scale: 0.8 });
      gsap.set(phrase, { autoAlpha: 0, y: 28 });
      gsap.set([grande, mas, quanto], { x: 0, scale: 1 });
      gsap.set(details, { autoAlpha: 0, pointerEvents: "none" });

      const hideDetails = () => gsap.set(details, { autoAlpha: 0, pointerEvents: "none" });

      const tl = gsap
        .timeline({ paused: true, onStart: hideDetails })
        .to(intro, {
          autoAlpha: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 0.78,
          ease: "power2.out"
        }, 0)
        .to(intro, {
          autoAlpha: 0,
          y: -50,
          scale: 0.96,
          duration: 0.7,
          ease: "power2.inOut"
        }, timing.introOut)
        .to(ok, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 0.76,
          ease: "power3.out"
        }, timing.okIn)
        .to(phrase, {
          autoAlpha: 1,
          y: 0,
          duration: 0.54,
          ease: "power2.out"
        }, timing.phraseIn)
        .to(ok, {
          autoAlpha: 0,
          y: -70,
          scale: 0.92,
          duration: 0.68,
          ease: "power2.inOut"
        }, timing.okOut)
        .to(phrase, {
          y: getPhraseLift,
          duration: 0.78,
          ease: "power2.inOut"
        }, timing.phraseLift)
        .to(grande, {
          scale: getGrandeScale,
          duration: 1.4,
          ease: "none"
        }, timing.expand)
        .to(mas, {
          x: () => -getGrandePush(),
          duration: 1.4,
          ease: "none"
        }, timing.expand)
        .to(quanto, {
          x: getGrandePush,
          duration: 1.4,
          ease: "none"
        }, timing.expand)
        .to(phrase, {
          y: getExitLift,
          autoAlpha: 0.86,
          duration: 0.48,
          ease: "power1.in"
        }, timing.phraseExit)
        .to({}, { duration: timing.hold })
        .set(details, { pointerEvents: "auto" })
        .to(details, {
          autoAlpha: 1,
          duration: 0.42,
          ease: "power2.out"
        });

      let hasPlayed = false;
      let playbackFrame = 0;
      let playbackObserver;

      const getViewportHeight = () => window.visualViewport?.height || window.innerHeight;
      const getVisibleRatio = () => {
        const rect = section.getBoundingClientRect();
        const viewportHeight = getViewportHeight();
        const visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
        return visibleHeight / Math.min(rect.height || viewportHeight, viewportHeight);
      };
      const isSectionFullyOutside = () => {
        const rect = section.getBoundingClientRect();
        const viewportHeight = getViewportHeight();
        return rect.bottom <= 0 || rect.top >= viewportHeight;
      };
      const playAnimation = () => {
        if (hasPlayed) return;
        hasPlayed = true;
        tl.restart();
      };
      const resetAnimation = () => {
        hasPlayed = false;
        tl.pause(0);
        hideDetails();
      };
      const syncPlayback = () => {
        if (isSectionFullyOutside()) {
          resetAnimation();
        } else if (getVisibleRatio() >= (isCompact ? 0.34 : 0.42)) {
          playAnimation();
        }
      };
      const queuePlaybackSync = () => {
        if (playbackFrame) return;
        playbackFrame = requestAnimationFrame(() => {
          playbackFrame = 0;
          syncPlayback();
        });
      };

      if ("IntersectionObserver" in window) {
        playbackObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              resetAnimation();
            } else if (entry.intersectionRatio >= (isCompact ? 0.34 : 0.42)) {
              playAnimation();
            }
          });
        }, {
          threshold: [0, 0.2, 0.34, 0.42, 0.6, 0.8]
        });
        playbackObserver.observe(section);
      }

      window.addEventListener("scroll", queuePlaybackSync, { passive: true });
      window.addEventListener("resize", queuePlaybackSync, { passive: true });
      window.visualViewport?.addEventListener("resize", queuePlaybackSync, { passive: true });

      okBreakCleanup = () => {
        if (playbackFrame) cancelAnimationFrame(playbackFrame);
        if (playbackObserver) playbackObserver.disconnect();
        window.removeEventListener("scroll", queuePlaybackSync);
        window.removeEventListener("resize", queuePlaybackSync);
        window.visualViewport?.removeEventListener("resize", queuePlaybackSync);
      };
      syncOkBreakScrollState = () => {};
      queuePlaybackSync();
      window.setTimeout(queuePlaybackSync, 240);

      const breakpointQuery = window.matchMedia("(max-width: 759px)");
      const rebuildForBreakpoint = () => requestAnimationFrame(initOkBreak);
      breakpointQuery.addEventListener("change", rebuildForBreakpoint);
      okBreakBreakpointCleanup = () => breakpointQuery.removeEventListener("change", rebuildForBreakpoint);
    }, section);
  }

  function refreshScrollAnimations() {
    const x = window.scrollX;
    const y = window.scrollY;
    const keepAnchor = pendingAnchorTarget && performance.now() <= pendingAnchorUntil;

    ScrollTrigger.refresh();
    if (keepAnchor) {
      applyPendingAnchor();
    } else if (Math.abs(window.scrollX - x) > 1 || Math.abs(window.scrollY - y) > 1) {
      window.scrollTo(x, y);
    }
    ScrollTrigger.update();
    syncOkBreakScrollState();
  }

  function scheduleScrollAnimationRefresh(delay = 0) {
    window.setTimeout(() => {
      requestAnimationFrame(refreshScrollAnimations);
    }, delay);
  }

  function initGenericReveals() {
    gsap.utils
      .toArray(".section-head, .service-grid article, .logo-row span, .marketplace-grid article")
      .filter((item) => !item.closest("#service-detail"))
      .forEach((item) => {
        gsap.from(item, {
          y: 70,
          opacity: 0,
          scrollTrigger: {
            trigger: item,
            start: "top 82%"
          }
        });
      });

    gsap.utils.toArray(".chapter").forEach((section) => {
      gsap.from(section.querySelectorAll("h2, p, .avatar, .contact-logo, .contact-card"), {
        y: 60,
        opacity: 0,
        stagger: 0.08,
        scrollTrigger: {
          trigger: section,
          start: "top 65%"
        }
      });

      const bg = section.querySelector(".photo-layer");
      if (bg) {
        gsap.to(bg, {
          scale: 1,
          yPercent: -8,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: 1
          }
        });
      }
    });

    initContactScene();
  }

  function initContactScene() {
    const section = document.querySelector(".contact");
    if (!section) return;

    const photo = section.querySelector(".contact-photo");
    const route = section.querySelector(".contact-map-route");
    const usaNode = section.querySelector(".contact-map-node--us");
    const usaPulse = section.querySelector(".contact-map-pulse--us");
    const particle = section.querySelector(".contact-map-particle");
    const routePath = window.matchMedia("(max-width: 760px)").matches
      ? "M48 96 C250 34 690 34 1018 72"
      : "M48 96 C126 50 224 44 318 72";
    const revealItems = [
      section.querySelector(".contact-kicker"),
      ...gsap.utils.toArray(section.querySelectorAll(".contact-copy h2 span")),
      section.querySelector(".contact-intro"),
      ...gsap.utils.toArray(section.querySelectorAll(".contact-benefit")),
      section.querySelector(".contact-form"),
      ...gsap.utils.toArray(section.querySelectorAll(".contact-links a")),
      section.querySelector(".contact-map")
    ].filter(Boolean);

    if (photo) {
      gsap.set(photo, { autoAlpha: 0, scale: 1.04, transformOrigin: "center" });
      gsap.to(photo, {
        yPercent: 3,
        scale: 1.01,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 1
        }
      });
    }

    let routeLength = 0;
    if (route && route.getTotalLength) {
      route.setAttribute("d", routePath);
      routeLength = route.getTotalLength();
      gsap.set(route, {
        strokeDasharray: routeLength,
        strokeDashoffset: routeLength
      });
    }

    gsap.set(revealItems, { autoAlpha: 0, y: 28 });
    gsap.set(section.querySelectorAll(".contact-copy h2 span"), { y: 34 });
    gsap.set([usaNode, usaPulse, particle].filter(Boolean), { autoAlpha: 0, scale: 0.72, transformOrigin: "center" });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 68%",
        toggleActions: "play none none reverse"
      }
    });

    tl
      .to(section.querySelector(".contact-kicker"), { autoAlpha: 1, y: 0, duration: 0.42, ease: "power3.out" })
      .to(section.querySelectorAll(".contact-copy h2 span"), {
        autoAlpha: 1,
        y: 0,
        duration: 0.58,
        ease: "power3.out",
        stagger: 0.08
      }, "-=0.18")
      .to(section.querySelector(".contact-intro"), { autoAlpha: 1, y: 0, duration: 0.48, ease: "power3.out" }, "-=0.2")
      .to(section.querySelectorAll(".contact-benefit"), {
        autoAlpha: 1,
        y: 0,
        duration: 0.42,
        ease: "power3.out",
        stagger: 0.07
      }, "-=0.18")
      .to(photo, { autoAlpha: 1, scale: 1.01, duration: 0.8, ease: "power2.out" }, "-=0.44")
      .to(section.querySelector(".contact-form"), { autoAlpha: 1, y: 0, duration: 0.58, ease: "power3.out" }, "-=0.52")
      .to(section.querySelectorAll(".contact-links a"), {
        autoAlpha: 1,
        y: 0,
        duration: 0.36,
        ease: "power3.out",
        stagger: 0.06
      }, "-=0.24")
      .to(section.querySelector(".contact-map"), { autoAlpha: 1, y: 0, duration: 0.34, ease: "power2.out" }, "-=0.18");

    if (routeLength) {
      tl
        .to(route, { strokeDashoffset: 0, duration: 1.45, ease: "power2.out" }, "-=0.04")
        .to([usaNode, usaPulse].filter(Boolean), {
          autoAlpha: 1,
          scale: 1,
          duration: 0.34,
          ease: "power3.out"
        }, "-=0.18");

      if (particle && hasMotionPath) {
        tl.to(particle, {
          autoAlpha: 1,
          duration: 0.12
        }, "-=1.08")
          .to(particle, {
            motionPath: {
              path: route,
              align: route,
              alignOrigin: [0.5, 0.5]
            },
            duration: 1.08,
            ease: "power1.inOut"
          }, "<")
          .to(particle, { autoAlpha: 0, duration: 0.22 }, "-=0.08");
      }
    }
  }

  function initCharts() {
    gsap.utils.toArray(".chart-bars i").forEach((bar) => {
      gsap.to(bar, {
        scaleY: 1,
        ease: "none",
        scrollTrigger: {
          trigger: bar.closest(".slide"),
          start: "top 72%",
          end: "bottom 45%",
          scrub: 1
        }
      });
    });
  }

  function initMarketComparison() {
    const section = document.querySelector(".market-comparison");
    if (!section) return;

    if (marketComparisonContext) {
      marketComparisonContext.revert();
    }

    marketComparisonContext = gsap.context(() => {
      const eyebrow = section.querySelector(".market-eyebrow");
      const titleLines = gsap.utils.toArray(section.querySelectorAll(".comparison-title span"));
      const subtitle = section.querySelector(".comparison-subtitle");
      const panels = gsap.utils.toArray(section.querySelectorAll(".comparison-panel"));
      const counters = gsap.utils.toArray(section.querySelectorAll("[data-comparison-counter]"));
      const growthLine = section.querySelector(".comparison-growth-line");
      const growthPoints = gsap.utils.toArray(section.querySelectorAll(".comparison-growth-points circle"));
      const bars = gsap.utils.toArray(section.querySelectorAll(".comparison-bar i"));
      const gaugeFill = section.querySelector(".comparison-gauge-fill");
      const gaugeDetails = gsap.utils.toArray(section.querySelectorAll(".comparison-cart-icon, .comparison-gauge text"));
      const contextItems = gsap.utils.toArray(section.querySelectorAll(".comparison-context > *"));

      if (!eyebrow || !titleLines.length || !subtitle || !panels.length || !counters.length || !growthLine || !gaugeFill) return;

      const isMobile = window.matchMedia("(max-width: 760px)").matches;
      const growthLineLength = growthLine.getTotalLength();
      const gaugeTarget = 100 - 23.1;
      const counterStates = counters.map((counter) => {
        const decimals = Number(counter.dataset.decimals || 0);
        const prefix = counter.dataset.prefix || "";
        const suffix = counter.dataset.suffix || "";
        const target = Number(counter.dataset.target || 0);
        const state = { value: isMobile ? target : 0 };
        const render = () => {
          counter.textContent = `${prefix}${state.value.toFixed(decimals).replace(".", ",")}${suffix}`;
        };

        render();
        return {
          state,
          render,
          target
        };
      });

      gsap.set([eyebrow, subtitle], { autoAlpha: 0, y: 18 });
      gsap.set(titleLines, { autoAlpha: 0, yPercent: 105 });
      gsap.set(panels, { autoAlpha: 0, y: 34, scale: 0.985 });
      gsap.set(growthLine, {
        strokeDasharray: growthLineLength,
        strokeDashoffset: growthLineLength
      });
      gsap.set(growthPoints, { autoAlpha: 0, scale: 0.62, transformOrigin: "center" });
      gsap.set(bars, { scaleY: 0, transformOrigin: "bottom" });
      gsap.set(gaugeFill, { strokeDasharray: 100, strokeDashoffset: 100 });
      gsap.set(gaugeDetails, { autoAlpha: 0, y: 10 });
      gsap.set(contextItems, { autoAlpha: 0, y: 22 });

      const headerTl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          id: "market-comparison-header",
          start: "top 88%",
          end: "top 50%",
          scrub: 0.24,
          invalidateOnRefresh: true
        }
      });

      headerTl
        .to(eyebrow, { autoAlpha: 1, y: 0, duration: 0.16, ease: "power2.out" }, 0)
        .to(titleLines, { autoAlpha: 1, yPercent: 0, stagger: 0.08, duration: 0.34, ease: "power3.out" }, 0.04)
        .to(subtitle, { autoAlpha: 1, y: 0, duration: 0.22, ease: "power2.out" }, 0.18);

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          id: "market-comparison-cards",
          start: "top 62%",
          end: "top -38%",
          scrub: 0.2,
          invalidateOnRefresh: true
        }
      });

      panels.forEach((panel, index) => {
        tl.to(panel, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 0.24,
          ease: "power3.out"
        }, index * 0.34);
      });

      counterStates.forEach(({ state, render, target }, index) => {
        tl.to(state, {
          value: target,
          duration: 0.3,
          ease: "power2.out",
          onUpdate: render
        }, index * 0.34 + 0.06);
      });

      tl
        .to(growthLine, { strokeDashoffset: 0, duration: 0.3, ease: "power1.inOut" }, 0.1)
        .to(growthPoints, { autoAlpha: 1, scale: 1, stagger: 0.07, duration: 0.2, ease: "back.out(1.5)" }, 0.28)
        .to(bars, { scaleY: 1, stagger: 0.07, duration: 0.32, ease: "power2.inOut" }, 0.43)
        .to(gaugeFill, { strokeDashoffset: gaugeTarget, duration: 0.34, ease: "power2.inOut" }, 0.74)
        .to(gaugeDetails, { autoAlpha: 1, y: 0, stagger: 0.04, duration: 0.22, ease: "power2.out" }, 0.88)
        .to(contextItems, { autoAlpha: 1, y: 0, stagger: 0.05, duration: 0.3, ease: "power2.out" }, 1)
        .to({}, { duration: 0.12 });
    }, section);
  }

  function initEcommerceGrowth() {
    const section = document.querySelector(".ecommerce-growth");
    if (!section) return;

    if (ecommerceGrowthContext) {
      ecommerceGrowthContext.revert();
    }

    ecommerceGrowthContext = gsap.context(() => {
      const eyebrow = section.querySelector(".market-eyebrow");
      const titleLines = gsap.utils.toArray(section.querySelectorAll(".market-title span"));
      const composition = section.querySelector(".market-story__composition");
      const growthMetric = section.querySelector(".market-metric--growth");
      const counter = section.querySelector("[data-market-counter]");
      const growthLabel = section.querySelector(".market-metric--growth .metric-label");
      const progress = section.querySelector(".metric-progress span");
      const chart = section.querySelector(".market-chart--growth");
      const growthLine = section.querySelector(".market-growth-line");
      const chartPoints = gsap.utils.toArray(section.querySelectorAll(".market-chart-points circle"));

      if (
        !eyebrow ||
        !titleLines.length ||
        !composition ||
        !growthMetric ||
        !counter ||
        !growthLabel ||
        !progress ||
        !chart ||
        !growthLine
      ) return;

      const isMobile = window.matchMedia("(max-width: 760px)").matches;
      const counterTarget = 6.5;
      const counterState = { value: isMobile ? counterTarget : 0 };
      const lineLength = growthLine.getTotalLength();
      const updateCounter = () => {
        counter.textContent = `${counterState.value.toFixed(1).replace(".", ",")}%`;
      };

      updateCounter();

      gsap.set(eyebrow, { autoAlpha: 0, y: 15 });
      gsap.set(titleLines, { yPercent: 112, autoAlpha: 0 });
      gsap.set(composition, { autoAlpha: 1 });
      gsap.set(growthMetric, { autoAlpha: 0, y: 34 });
      gsap.set(growthLabel, { autoAlpha: 0, y: 18 });
      gsap.set(progress, { scaleX: 0 });
      gsap.set(chart, { autoAlpha: 0, y: 32 });
      gsap.set(growthLine, { strokeDasharray: lineLength, strokeDashoffset: lineLength });
      gsap.set(chartPoints, { autoAlpha: 0, scale: 0.5, transformOrigin: "center" });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: section,
            id: "ecommerce-growth-reveal",
            start: "top 74%",
            end: "top 14%",
            scrub: 0.26,
            invalidateOnRefresh: true
          }
        })
        .to(eyebrow, { autoAlpha: 1, y: 0, duration: 0.16, ease: "power2.out" }, 0.04)
        .to(titleLines, { yPercent: 0, autoAlpha: 1, stagger: 0.04, duration: 0.34, ease: "power3.out" }, 0.12)
        .to(growthMetric, { autoAlpha: 1, y: 0, duration: 0.28, ease: "power3.out" }, 0.26)
        .to(counterState, {
          value: counterTarget,
          duration: 0.38,
          ease: "power2.out",
          onUpdate: updateCounter
        }, 0.32)
        .to(progress, { scaleX: 1, duration: 0.34, ease: "power2.inOut" }, 0.32)
        .to(growthLabel, { autoAlpha: 1, y: 0, duration: 0.22, ease: "power2.out" }, 0.44)
        .to(chart, { autoAlpha: 1, y: 0, duration: 0.28, ease: "power2.out" }, 0.52)
        .to(growthLine, { strokeDashoffset: 0, duration: 0.42, ease: "power1.inOut" }, 0.6)
        .to(chartPoints, { autoAlpha: 1, scale: 1, stagger: 0.06, duration: 0.2, ease: "back.out(1.5)" }, 0.78);

    }, section);
  }

  function initOperationFlow() {
    if (operationFlowContext) {
      operationFlowContext.revert();
    }

    const section = document.querySelector(".operation-flow");
    const stage = section?.querySelector(".pin-stage");
    const title = section?.querySelector(".flow-title");
    const bg = section?.querySelector(".operation-flow__bg");
    const shade = section?.querySelector(".operation-flow__shade");
    const diagram = section?.querySelector(".flow-diagram");
    const flowSteps = section ? gsap.utils.toArray(section.querySelectorAll(".flow-step")) : [];
    const flowLines = section ? gsap.utils.toArray(section.querySelectorAll(".flow-line")) : [];
    const originItems = section ? gsap.utils.toArray(section.querySelectorAll(".origin-item")) : [];
    const marketplaceLogos = section ? gsap.utils.toArray(section.querySelectorAll(".marketplace-logo")) : [];
    const brandChannel = section?.querySelector(".brand-channel");
    const isMobile = window.matchMedia("(max-width: 760px)").matches;
    if (
      !section ||
      !stage ||
      !title ||
      !bg ||
      !shade ||
      !diagram ||
      !flowSteps.length ||
      !flowLines.length ||
      !brandChannel
    ) return;

    if (isMobile) {
      const mobileShell = section.querySelector(".flow-mobile-shell");
      const mobileDiagram = section.querySelector(".flow-mobile-diagram");
      const mobileSteps = gsap.utils.toArray(section.querySelectorAll(".mobile-flow-step"));
      const mobileLines = gsap.utils.toArray(section.querySelectorAll(".mobile-flow-line"));
      const mobileOriginLines = gsap.utils.toArray(section.querySelectorAll(".mobile-origin-side"));
      const mobileOriginCenter = section.querySelector(".mobile-origin-center");
      const mobileLineBrazil = section.querySelector(".mobile-line-br");
      const mobileLineCustoms = section.querySelector(".mobile-line-customs");
      const mobileLineUs = section.querySelector(".mobile-line-us");
      const mobileLineMarket = section.querySelector(".mobile-line-market-center");
      const mobileMarketArrows = gsap.utils.toArray(section.querySelectorAll(".mobile-market-arrow"));
      const mobileLineConsumers = section.querySelector(".mobile-line-consumers");
      const mobileMarketplaces = gsap.utils.toArray(section.querySelectorAll(".mobile-marketplace-logo"));

      if (
        !mobileShell ||
        !mobileDiagram ||
        !mobileSteps.length ||
        !mobileLines.length ||
        !mobileOriginLines.length ||
        !mobileOriginCenter ||
        !mobileLineBrazil ||
        !mobileLineCustoms ||
        !mobileLineUs ||
        !mobileLineMarket ||
        !mobileMarketArrows.length ||
        !mobileLineConsumers ||
        !mobileMarketplaces.length
      ) return;

      operationFlowContext = gsap.context(() => {
        const mobileDraw = (targets, duration = 0.5, stagger = 0.06) => ({
          strokeDashoffset: 0,
          autoAlpha: 1,
          duration,
          stagger,
          ease: "power2.inOut"
        });
        const reveal = (options = {}) => ({
          autoAlpha: 1,
          y: 0,
          scale: 1,
          filter: "brightness(1.08)",
          duration: options.duration || 0.42,
          stagger: options.stagger || 0,
          ease: "power2.out"
        });

        gsap.set(stage, { "--flow-glow-x": "50%" });
        gsap.set(title, { x: 0, y: 0, scale: 1, opacity: 1 });
        gsap.set(mobileSteps, {
          autoAlpha: 0,
          y: 26,
          scale: 0.96,
          filter: "brightness(0.72)",
          transformOrigin: "center"
        });
        gsap.set(section.querySelector(".mobile-origin-grid"), {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          filter: "brightness(1.08)"
        });
        gsap.set(mobileMarketplaces, { autoAlpha: 0, x: 20, y: 8 });
        mobileLines.forEach((path) => {
          const length = path.getTotalLength();
          gsap.set(path, { strokeDasharray: length, strokeDashoffset: length, autoAlpha: 0 });
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: mobileShell,
            id: "operation-flow-mobile",
            start: "top 72%",
            end: "bottom 76%",
            scrub: 0.62,
            invalidateOnRefresh: true
          }
        });

        tl
          .to(section.querySelector(".mobile-origin-grid"), reveal({ duration: 0.5 }))
          .to(mobileOriginLines, mobileDraw(mobileOriginLines, 0.42), ">-0.08")
          .to(mobileOriginCenter, mobileDraw(mobileOriginCenter, 0.58, 0), ">-0.06")
          .to(section.querySelector(".mobile-node-br"), reveal(), ">-0.18")
          .to(mobileLineBrazil, mobileDraw(mobileLineBrazil, 0.48, 0), ">-0.04")
          .to(section.querySelector(".mobile-node-customs"), reveal(), ">-0.18")
          .to(mobileLineCustoms, mobileDraw(mobileLineCustoms, 0.48, 0), ">-0.04")
          .to(section.querySelector(".mobile-node-us"), reveal(), ">-0.18")
          .to(mobileLineUs, mobileDraw(mobileLineUs, 0.48, 0), ">-0.04")
          .to(section.querySelector(".mobile-brand-channel"), reveal(), ">-0.18")
          .to(mobileLineMarket, mobileDraw(mobileLineMarket, 0.58, 0), ">-0.04")
          .to(mobileMarketArrows, mobileDraw(mobileMarketArrows, 0.38, 0.08), ">-0.02")
          .to(mobileMarketplaces, {
            autoAlpha: 1,
            x: 0,
            y: 0,
            duration: 0.34,
            stagger: 0.08,
            ease: "power2.out"
          }, "<0.08")
          .to(mobileLineConsumers, mobileDraw(mobileLineConsumers, 0.56, 0), ">-0.04")
          .to(section.querySelector(".mobile-node-consumers"), reveal({ duration: 0.48 }), ">-0.2")
          .to({}, { duration: 0.32 });
      }, section);
      return;
    }

    operationFlowContext = gsap.context(() => {
      const originLines = gsap.utils.toArray(section.querySelectorAll(".origin-line"));
      const lineBrazil = section.querySelector(".line-br");
      const lineCustoms = section.querySelector(".line-customs");
      const lineUsWarehouse = section.querySelector(".line-us-warehouse");
      const lineChannels = section.querySelector(".line-channels");
      const branchLines = gsap.utils.toArray(section.querySelectorAll(".branch-line"));
      const channelOutLines = gsap.utils.toArray(section.querySelectorAll(".line-to-consumers"));
      const titleCenterX = () => Math.max(0, (window.innerWidth - title.offsetWidth) / 2 - title.offsetLeft);
      const stepState = (activeIndex) => ({
        autoAlpha: (index) => (index <= activeIndex ? 1 : 0.22),
        scale: (index) => (index === activeIndex ? 1 : index < activeIndex ? 0.99 : 0.92),
        filter: (index) => (index === activeIndex ? "brightness(1.24)" : index < activeIndex ? "brightness(1.08)" : "brightness(0.58)"),
        duration: 0.45,
        ease: "power2.out"
      });
      const draw = (targets, duration = 0.55) => ({
        strokeDashoffset: 0,
        autoAlpha: 1,
        duration,
        stagger: Array.isArray(targets) && targets.length > 1 ? 0.07 : 0,
        ease: "power2.inOut"
      });

      gsap.set(stage, { "--flow-glow-x": "14%" });
      gsap.set(title, {
        x: isMobile ? 0 : titleCenterX,
        y: () => window.innerHeight * (isMobile ? 0.26 : 0.34),
        scale: isMobile ? 1 : 1.15,
        opacity: 1
      });
      gsap.set(diagram, { autoAlpha: 0, y: isMobile ? 24 : 42, scale: isMobile ? 1 : 1.02 });
      gsap.set(flowSteps, { autoAlpha: 0.22, scale: 0.92, filter: "brightness(0.58)", transformOrigin: "center" });
      gsap.set(flowSteps[0], { autoAlpha: 1, scale: 1, filter: "brightness(1.1)" });
      gsap.set(originItems, { autoAlpha: 0, y: 34 });
      gsap.set([brandChannel, ...marketplaceLogos], { autoAlpha: 0, y: 18 });
      gsap.set(marketplaceLogos, { x: 30 });
      flowLines.forEach((path) => {
        const length = path.getTotalLength();
        gsap.set(path, { strokeDasharray: length, strokeDashoffset: length, autoAlpha: 0 });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          id: "operation-flow",
          start: "top top",
          end: "+=220%",
          pin: section,
          pinSpacing: true,
          scrub: 0.65,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      tl
        .to(title, { x: 0, y: 0, scale: isMobile ? 0.82 : 0.56, opacity: 0.76, duration: 0.72, ease: "power2.inOut" })
        .to(diagram, { autoAlpha: 1, y: 0, scale: 1, duration: 0.58, ease: "power2.out" }, "<0.16")
        .to(originItems, { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.15, ease: "power2.out" }, "<0.16")
        .to(originLines, draw(originLines, 0.5), ">-0.1")
        .to({}, { duration: 0.38 })

        .to(flowSteps, stepState(1))
        .to(stage, { "--flow-glow-x": "31%", duration: 0.72, ease: "none" }, "<")
        .to(lineBrazil, draw(lineBrazil, 0.72), "<")
        .to({}, { duration: 0.48 })

        .to(flowSteps, stepState(2))
        .to(stage, { "--flow-glow-x": "46%", duration: 0.72, ease: "none" }, "<")
        .to(lineCustoms, draw(lineCustoms, 0.72), "<")
        .to({}, { duration: 0.48 })

        .to(flowSteps, stepState(3))
        .to(stage, { "--flow-glow-x": "60%", duration: 0.72, ease: "none" }, "<")
        .to(lineUsWarehouse, draw(lineUsWarehouse, 0.72), "<")
        .to({}, { duration: 0.48 })

        .to(flowSteps, stepState(4))
        .to(stage, { "--flow-glow-x": "76%", duration: 0.64, ease: "none" }, "<")
        .to(lineChannels, draw(lineChannels, 0.48), "<")
        .to(section.querySelector(".branch-site"), draw(section.querySelector(".branch-site"), 0.48))
        .to(brandChannel, { autoAlpha: 1, y: 0, duration: 0.42, ease: "power2.out" }, "<0.08")
        .to(branchLines.filter((line) => !line.classList.contains("branch-site")), draw(branchLines, 0.58), ">-0.06")
        .to(marketplaceLogos, { autoAlpha: 1, x: 0, y: 0, duration: 0.46, stagger: 0.1, ease: "power2.out" }, "<0.1")
        .to({}, { duration: 0.48 })

        .to(flowSteps, stepState(5))
        .to(stage, { "--flow-glow-x": "92%", duration: 0.72, ease: "none" }, "<")
        .to(channelOutLines, draw(channelOutLines, 0.72), "<")
        .to({}, { duration: 0.45 })

        .to(flowSteps, {
          autoAlpha: 0.76,
          scale: 0.98,
          filter: "brightness(1.04)",
          duration: 0.6,
          ease: "power2.inOut"
        })
        .to(diagram, { scale: 0.88, duration: 0.6, ease: "power2.inOut" }, "<");
    }, section);
  }

  function initProjectCases() {
    initPkxdCase();
    initApisvidaCase();
  }

  function initProjectWall() {
    const section = document.querySelector(".project-wall");
    if (!section) return;

    if (projectWallContext) {
      projectWallContext.revert();
    }

    projectWallContext = gsap.context(() => {
      const mosaic = section.querySelector(".projects-mosaic");
      const rows = gsap.utils.toArray(section.querySelectorAll(".projects-mosaic__row"));

      const shots = gsap.utils.toArray(section.querySelectorAll(".project-shot"));
      const chapterLabel = section.querySelector(".flow-next-label");
      const casesWord = section.querySelector(".cases-word");
      const separator = section.querySelector(".flow-next-separator");
      const projectsWord = section.querySelector(".projects-word");
      const copy = section.querySelector(".project-wall__copy");
      const cta = section.querySelector(".project-wall__cta");

      if (!mosaic || !rows.length || !shots.length || !chapterLabel || !casesWord || !separator || !projectsWord || !copy || !cta) return;

      const isMobile = window.matchMedia("(max-width: 760px)").matches;
      const isTablet = window.matchMedia("(max-width: 1100px)").matches;
      const mosaicMotion = isMobile
        ? { fromX: -58, fromY: 36, toX: 58, toY: -42 }
        : isTablet
          ? { fromX: -120, fromY: 66, toX: 128, toY: -76 }
          : { fromX: -185, fromY: 108, toX: 195, toY: -122 };

      gsap.set(mosaic, {
        x: mosaicMotion.fromX,
        y: mosaicMotion.fromY,
        scale: 1.04,
        rotation: isMobile ? -4 : -4.8,
        transformOrigin: "center"
      });

      gsap.to(mosaic, {
        x: mosaicMotion.toX,
        y: mosaicMotion.toY,
        scale: 1,
        rotation: isMobile ? -4 : -4.8,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const rowMotion = isMobile
        ? [
            { fromX: -18, toX: 18 },
            { fromX: -12, toX: 24 },
            { fromX: -24, toX: 14 }
          ]
        : [
            { fromX: -70, toX: 62 },
            { fromX: -48, toX: 78 },
            { fromX: -82, toX: 56 }
          ];

      rows.forEach((row, index) => {
        const motion = rowMotion[index] || rowMotion[0];
        gsap.fromTo(row, {
          x: motion.fromX
        }, {
          x: motion.toX,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.15,
            invalidateOnRefresh: true
          }
        });
      });

      gsap.from(shots, {
        autoAlpha: 0,
        y: 32,
        scale: 0.985,
        duration: 0.8,
        stagger: 0.045,
        ease: "power2.out",
        immediateRender: false,
        transformOrigin: "center",
        scrollTrigger: {
          trigger: section,
          start: isMobile ? "top 90%" : "top 82%",
          once: true
        }
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: section,
            start: isMobile ? "top 88%" : "top 70%",
            once: true
          }
        })
        .from(chapterLabel, { autoAlpha: 0, y: 18, duration: 0.36, ease: "power2.out", immediateRender: false })
        .from(casesWord, { yPercent: 118, duration: 0.7, ease: "power3.out", immediateRender: false }, ">-0.04")
        .from(separator, { autoAlpha: 0, scaleY: 0, yPercent: 6, duration: 0.42, ease: "power2.out", immediateRender: false }, "-=0.24")
        .from(projectsWord, { yPercent: 118, duration: 0.7, ease: "power3.out", immediateRender: false }, "-=0.18")
        .from(copy, { autoAlpha: 0, y: 22, duration: 0.42, ease: "power2.out", immediateRender: false }, "-=0.16")
        .from(cta, { autoAlpha: 0, y: 22, duration: 0.42, ease: "power2.out", immediateRender: false }, "-=0.22");
    }, section);
  }

  function initCaseShowcaseVideos() {
    const videos = Array.from(
      document.querySelectorAll(".showcase-phone__video[data-src], .showcase-phone__video[data-src-desktop]")
    );
    if (!videos.length) return;

    const mobileQuery = window.matchMedia("(max-width: 760px)");

    const resolveSrc = (video) => {
      const desktop = video.dataset.srcDesktop;
      const mobile = video.dataset.srcMobile || video.dataset.src;
      if (desktop && mobile) {
        return mobileQuery.matches ? mobile : desktop;
      }
      return mobile || desktop || video.dataset.src || "";
    };

    const syncSources = () => {
      videos.forEach((video) => {
        const src = resolveSrc(video);
        if (!src || video.getAttribute("src") === src) return;
        const wasPlaying = !video.paused;
        video.setAttribute("src", src);
        video.load();
        if (wasPlaying) video.play().catch(() => {});
      });
    };

    syncSources();
    mobileQuery.addEventListener("change", syncSources);

    if (!("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionVideos = Array.from(
          entry.target.querySelectorAll(".showcase-phone__video[data-src], .showcase-phone__video[data-src-desktop]")
        );

        sectionVideos.forEach((video) => {
          if (entry.isIntersecting) {
            if (!video.getAttribute("src")) {
              const src = resolveSrc(video);
              if (src) {
                video.setAttribute("src", src);
                video.load();
              }
            }
            video.play().catch(() => {});
            return;
          }

          video.pause();
        });
      });
    }, {
      rootMargin: "220px 0px",
      threshold: 0.18
    });

    document.querySelectorAll(".cases-showcase").forEach((section) => observer.observe(section));
  }

  function initCaseShowcase() {
    const section = document.querySelector(".cases-showcase");
    if (!section) return;

    if (caseShowcaseContext) {
      caseShowcaseContext.revert();
    }

    caseShowcaseContext = gsap.context(() => {
      const bg = section.querySelector(".cases-showcase__bg");
      const panel = section.querySelector(".cases-showcase__panel");
      const projects = gsap.utils.toArray(section.querySelectorAll(".showcase-project"));
      const phones = gsap.utils.toArray(section.querySelectorAll(".showcase-phone"));
      const projectText = gsap.utils.toArray(section.querySelectorAll(".showcase-project__info > *"));
      const divider = section.querySelector(".cases-showcase__divider");
      const features = gsap.utils.toArray(section.querySelectorAll(".showcase-feature"));
      const isMobile = window.matchMedia("(max-width: 760px)").matches;

      if (!panel || !projects.length) return;

      if (bg && !isMobile) {
        gsap.fromTo(bg, {
          y: 0
        }, {
          y: 60,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true
          }
        });
      }

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 84%",
          toggleActions: "play none none reverse"
        }
      });

      timeline
        .fromTo(panel, {
          autoAlpha: 0,
          x: isMobile ? 50 : "40vw"
        }, {
          autoAlpha: 1,
          x: 0,
          duration: 1,
          ease: "power4.out"
        })
        .fromTo(projects, {
          autoAlpha: 0,
          x: isMobile ? -25 : -64,
          y: isMobile ? 35 : 56
        }, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 0.78,
          stagger: 0.1,
          ease: "power3.out"
        }, "-=0.8")
        .fromTo(phones, {
          autoAlpha: 0,
          scale: 1,
          y: 0
        }, {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          duration: 0.68,
          stagger: 0.1,
          ease: "power3.out"
        }, "-=0.58")
        .fromTo(projectText, {
          autoAlpha: 0,
          y: 14
        }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.36,
          stagger: 0.04,
          ease: "power3.out"
        }, "-=0.52");

      if (divider) {
        timeline.fromTo(divider, {
          scaleX: 0,
          transformOrigin: "left center"
        }, {
          scaleX: 1,
          duration: 0.62,
          ease: "power3.out"
        }, "-=0.22");
      }

      if (features.length) {
        timeline.fromTo(features, {
          autoAlpha: 0,
          y: 20
        }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.48,
          stagger: 0.08,
          ease: "power3.out"
        }, "-=0.42");
      }
    }, section);
  }

  function tweenCounter(target, value, suffix = "", prefix = "") {
    const state = { value: 0 };
    return gsap.to(state, {
      value,
      duration: 0.56,
      paused: true,
      ease: "power2.out",
      onUpdate: () => {
        target.textContent = `${prefix}${Math.round(state.value)}${suffix}`;
      }
    });
  }

  function initServiceDetails() {
    const section = document.querySelector("#service-detail");
    if (!section) return;

    if (serviceDetailContext) {
      serviceDetailContext.revert();
    }

    serviceDetailContext = gsap.context(() => {
      const eyebrow = section.querySelector(".section-head p");
      const title = section.querySelector(".section-head h2");
      const cards = gsap.utils.toArray(section.querySelectorAll(".detailed-grid article"));

      if (!eyebrow || !title || !cards.length) return;

      const revealCard = (timeline, card, start = 0) => {
        const number = card.querySelector("span");
        const cardTitle = card.querySelector("h3");
        const items = card.querySelectorAll("li");

        timeline
          .to(card, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.65,
            ease: "power3.out"
          }, start)
          .to(number, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.35,
            ease: "power2.out"
          }, start + 0.12)
          .to(cardTitle, {
            autoAlpha: 1,
            y: 0,
            duration: 0.35,
            ease: "power2.out"
          }, start + 0.18)
          .to(items, {
            autoAlpha: 1,
            y: 0,
            duration: 0.25,
            stagger: 0.025,
            ease: "power2.out"
          }, start + 0.23);
      };

      gsap.set([eyebrow, title], { autoAlpha: 0, y: 25 });
      cards.forEach((card) => {
        gsap.set(card, { autoAlpha: 0, y: 50, scale: 0.97, transformOrigin: "center bottom" });
        gsap.set(card.querySelector("span"), {
          autoAlpha: 0,
          y: 15,
          scale: 0.9,
          transformOrigin: "left center"
        });
        gsap.set(card.querySelector("h3"), { autoAlpha: 0, y: 10 });
        gsap.set(card.querySelectorAll("li"), { autoAlpha: 0, y: 8 });
      });

      if (window.matchMedia("(max-width: 760px)").matches) {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: section,
              start: "top 78%",
              once: true
            }
          })
          .to(eyebrow, { autoAlpha: 1, y: 0, duration: 0.38, ease: "power2.out" })
          .to(title, { autoAlpha: 1, y: 0, duration: 0.42, ease: "power2.out" }, "<0.06");

        cards.forEach((card) => {
          const cardTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: card,
              start: "top 82%",
              once: true
            }
          });

          revealCard(cardTimeline, card);
        });

        return;
      }

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 70%",
          once: true
        }
      });

      timeline
        .to(eyebrow, { autoAlpha: 1, y: 0, duration: 0.38, ease: "power2.out" }, 0)
        .to(title, { autoAlpha: 1, y: 0, duration: 0.42, ease: "power2.out" }, 0.06);

      cards.forEach((card, index) => {
        revealCard(timeline, card, 0.18 + index * 0.13);
      });
    }, section);
  }

  function initPkxdCase() {
    const section = document.querySelector(".case-pkxd");
    if (!section) return;

    if (pkxdCaseContext) {
      pkxdCaseContext.revert();
    }

    pkxdCaseContext = gsap.context(() => {
      const chapter = section.querySelector(".project-case__chapter");
      const logo = section.querySelector(".case-logo");
      const opening = section.querySelector(".case-opening p");
      const metrics = gsap.utils.toArray(section.querySelectorAll(".case-metric"));
      const metricNumbers = gsap.utils.toArray(section.querySelectorAll(".case-metric strong"));
      const device = section.querySelector(".pkxd-device");
      const timeline = section.querySelector(".pkxd-timeline");
      const rail = section.querySelector(".timeline-rail span");
      const y2025 = section.querySelector(".year-panel--2025");
      const y2025Text = y2025?.querySelectorAll("h3, p");
      const y2026 = section.querySelector(".year-panel--2026");
      const y2026Text = y2026?.querySelectorAll("h3, p");
      const countries = gsap.utils.toArray(section.querySelectorAll(".country-list li"));
      const distribution = section.querySelector(".distribution-nodes");
      const nodes = gsap.utils.toArray(section.querySelectorAll(".distribution-node"));
      const globalLabel = section.querySelector(".global-label");
      const final = section.querySelector(".case-final");
      const isMobile = window.matchMedia("(max-width: 760px)").matches;

      if (!chapter || !logo || !opening || !metrics.length || !device || !timeline || !rail || !y2025 || !y2026 || !distribution || !final) return;

      gsap.set(chapter, { autoAlpha: 0, scale: 0.92 });
      gsap.set(logo, { autoAlpha: 1, y: 0, scale: 1, x: 0 });
      gsap.set(opening, { autoAlpha: 1, y: 0, x: 0, scale: 1 });
      gsap.set(metrics, { autoAlpha: 0, y: 40, scale: 0.94, x: 0 });
      gsap.set(device, { autoAlpha: 0, x: 0, y: 80, rotation: -12, scale: 0.9 });
      gsap.set(timeline, { autoAlpha: 0, x: 0, y: 0 });
      gsap.set(rail, { scaleY: 0 });
      gsap.set(y2025, { autoAlpha: 0, y: 48, scale: 0.96, x: 0 });
      gsap.set(y2026, { autoAlpha: 0, y: 60, scale: 0.92, x: 0 });
      gsap.set(distribution, { "--distribution-line": 0, "--global-line": 0 });
      gsap.set(countries, { autoAlpha: 0, x: 30 });
      gsap.set(nodes, { autoAlpha: 0, y: 30, scale: 0.94 });
      gsap.set(globalLabel, { autoAlpha: 0, y: 12 });
      gsap.set(final, { autoAlpha: 0, xPercent: -50, y: 30, scale: 0.98 });

      metricNumbers.forEach((number) => {
        number.textContent = `0${number.dataset.suffix || ""}`;
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          id: "case-pkxd",
          start: projectCaseScroll.pkxd.start,
          end: projectCaseScroll.pkxd.end,
          scrub: projectCaseScroll.scrub,
          invalidateOnRefresh: true
        }
      });

      tl
        .addLabel("intro")
        .to({}, { duration: 0.2 })
        .addLabel("metrics")
        .to(metrics, { autoAlpha: 1, y: 0, scale: 1, stagger: 0.08, duration: 0.5 }, ">-0.08");

      metricNumbers.forEach((number) => {
        tl.add(tweenCounter(number, Number(number.dataset.count), number.dataset.suffix || ""), "<");
      });

      tl
        .to({}, { duration: 0.2 })
        .addLabel("device")
        .to(device, { autoAlpha: 1, y: 0, rotation: -12, scale: 1, duration: 0.7, ease: "power3.out" })
        .to({}, { duration: 0.18 })
        .to(isMobile ? [opening, ...metrics] : [], { autoAlpha: 0, y: -18, duration: 0.22, ease: "power2.inOut" }, ">-0.04")
        .addLabel("2025")
        .to(timeline, { autoAlpha: 1, duration: 0.28 })
        .to(y2025, { autoAlpha: 1, y: 0, scale: 1, duration: 0.54, ease: "power3.out" }, "<0.04")
        .to(countries, { autoAlpha: 1, x: 0, stagger: 0.1, duration: 0.34 }, ">-0.1")
        .to(rail, { scaleY: 0.48, duration: 0.4, ease: "power2.inOut" }, "<")
        .to({}, { duration: 0.18 })
        .addLabel("2026")
        .to(y2026, { autoAlpha: 1, y: 0, scale: 1, duration: 0.62, ease: "power3.out" })
        .to(rail, { scaleY: 0.78, duration: 0.42, ease: "power2.inOut" }, "<0.08")
        .to({}, { duration: 0.18 })
        .addLabel("origins")
        .to(nodes, { autoAlpha: 1, y: 0, scale: 1, stagger: 0.1, duration: 0.42 }, "-=0.06")
        .to(distribution, { "--distribution-line": 1, "--global-line": 1, duration: 0.36, ease: "power2.inOut" }, ">-0.06")
        .to(globalLabel, { autoAlpha: 1, y: 0, duration: 0.32 }, ">-0.06")
        .to(rail, { scaleY: 1, duration: 0.34, ease: "power2.inOut" }, "<")
        .to({}, { duration: 0.2 })
        .addLabel("final")
        .to({}, { duration: 0.24 });
    }, section);
  }

  function initApisvidaCase() {
    const section = document.querySelector(".case-apisvida");
    if (!section) return;

    if (apisvidaCaseContext) {
      apisvidaCaseContext.revert();
    }

    apisvidaCaseContext = gsap.context(() => {
      const chapter = section.querySelector(".project-case__chapter");
      const logo = section.querySelector(".case-logo");
      const opening = section.querySelector(".case-opening p");
      const stat = section.querySelector(".apis-stat");
      const statNumber = section.querySelector(".apis-stat strong");
      const flow = section.querySelector(".apis-flow");
      const flowPath = section.querySelector(".apis-flow-line path");
      const steps = gsap.utils.toArray(section.querySelectorAll(".apis-step"));
      const phone = section.querySelector(".apis-phone");
      const marketplace = section.querySelector(".apis-marketplace");
      const final = section.querySelector(".case-final");
      const isMobile = window.matchMedia("(max-width: 760px)").matches;

      if (!chapter || !logo || !opening || !stat || !statNumber || !flow || !flowPath || !steps.length || !phone || !marketplace || !final) return;

      gsap.set(chapter, { autoAlpha: 0, xPercent: 16, scale: 0.94 });
      gsap.set(logo, { autoAlpha: 1, y: 0, x: 0, scale: 1 });
      gsap.set(opening, { autoAlpha: 1, y: 0, x: 0, scale: 1 });
      gsap.set(stat, { autoAlpha: 0, y: 0, scale: 1 });
      gsap.set(flow, { autoAlpha: 0, y: 0 });
      gsap.set(flowPath, { strokeDashoffset: 950 });
      gsap.set(steps, { autoAlpha: 0, y: 34, scale: 0.92 });
      gsap.set(phone, { autoAlpha: 0, x: -120, y: 78, rotation: -4, scale: 0.96 });
      gsap.set(marketplace, { autoAlpha: 0, x: 140, y: 96, rotation: 5, scale: 0.9 });
      gsap.set(final, { autoAlpha: 0, xPercent: -50, y: 30, scale: 0.98 });
      statNumber.textContent = "0%";

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          id: "case-apisvida",
          start: projectCaseScroll.apisvida.start,
          end: projectCaseScroll.apisvida.end,
          scrub: projectCaseScroll.scrub,
          invalidateOnRefresh: true
        }
      });

      tl
        .addLabel("intro")
        .to({}, { duration: 0.08 })
        .addLabel("brand")
        .to(isMobile ? opening : [], { autoAlpha: 0, y: -18, duration: 0.2, ease: "power2.inOut" })
        .to(flow, { autoAlpha: 1, duration: 0.18 })
        .to(steps[0], { autoAlpha: 1, y: 0, scale: 1, duration: 0.28, ease: "power2.out" }, "<0.04")
        .to(phone, { autoAlpha: 1, x: 0, y: 0, rotation: 0, scale: 1, duration: 0.42, ease: "power3.out" }, "<0.06")
        .to(flowPath, { strokeDashoffset: 650, duration: 0.3, ease: "power2.inOut" }, "<");

      tl.add(tweenCounter(statNumber, 62, "%"), "<");

      tl
        .addLabel("operation")
        .to(steps[1], { autoAlpha: 1, y: 0, scale: 1, duration: 0.26, ease: "power2.out" }, ">-0.18")
        .to(flowPath, { strokeDashoffset: 330, duration: 0.3, ease: "power2.inOut" }, "<")
        .addLabel("marketplaces")
        .to(steps[2], { autoAlpha: 1, y: 0, scale: 1, duration: 0.26, ease: "power2.out" }, ">-0.14")
        .to(marketplace, { autoAlpha: 1, x: 0, y: 0, rotation: 2.2, scale: 1, duration: 0.42, ease: "power3.out" }, "<0.04")
        .to(flowPath, { strokeDashoffset: 0, duration: 0.28, ease: "power2.inOut" }, "<")
        .to({}, { duration: 0.12 })
        .addLabel("final")
        .to({}, { duration: 0.14 });
    }, section);
  }

  function initBrandStory() {
    const section = document.querySelector(".brand-story");
    if (!section) return;

    const lead = section.querySelector(".story-lead");
    const body = gsap.utils.toArray(section.querySelectorAll(".story-body p"));
    const symbol = section.querySelector(".brand-story__symbol");

    gsap.set(symbol, { autoAlpha: 0.28, x: -18 });
    gsap.set([lead, ...body], { autoAlpha: 0, y: 34 });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: section,
          id: "akag-story",
          start: "top 78%",
          end: "center 45%",
          scrub: 1,
          invalidateOnRefresh: true
        }
      })
      .to(symbol, { autoAlpha: 1, x: 0, duration: 0.18, ease: "power2.out" }, 0)
      .to(lead, { autoAlpha: 1, y: 0, duration: 0.34, ease: "power2.out" }, 0.24)
      .to(body, { autoAlpha: 1, y: 0, duration: 0.34, stagger: 0.08, ease: "power2.out" }, 0.44);
  }

  function initClients() {
    const section = document.querySelector(".clients");
    if (!section) return;

    const groups = gsap.utils.toArray(section.querySelectorAll(".client-group"));
    const upLogos = gsap.utils.toArray(section.querySelectorAll(".client-wall--up .client-logo"));
    const risingLogos = gsap.utils.toArray(section.querySelectorAll(".client-wall--rising .client-logo"));
    const logos = [...upLogos, ...risingLogos];
    const wall = section.querySelector(".client-wall");

    gsap.set(groups, { clearProps: "transform,opacity" });
    gsap.set(wall, { clearProps: "transform,opacity" });
    gsap.set(logos, { autoAlpha: 0, y: 58, scale: 0.86, filter: "blur(10px)" });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 82%",
          end: "center 48%",
          scrub: 0.18,
          invalidateOnRefresh: true
        }
      })
      .to(upLogos, {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        filter: "blur(0px)",
        stagger: 0.08,
        duration: 0.46,
        ease: "power3.out"
      })
      .to(upLogos, { scale: 1.03, ease: "none", duration: 0.16 })
      .to(risingLogos, {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        filter: "blur(0px)",
        stagger: 0.08,
        duration: 0.42,
        ease: "power3.out"
      }, "-=0.18")
      .to(logos, { scale: 1.02, ease: "none", duration: 0.2 })
      .to({}, { duration: 0.1 });
  }

  function initGlobal() {
    if (globalAbort) {
      globalAbort.abort();
    }
    globalAbort = new AbortController();

    if (globalRoot) {
      globalRoot.dispose();
      globalRoot = null;
    }

    if (globalContext) {
      globalContext.revert();
      gsap.set(".world-map, .global-copy", { clearProps: "all" });
    }

    globalContext = gsap.context(buildGlobal);
  }

  function buildGlobal() {
    const mapEl = document.getElementById("global-map-chart");
    const on = (target, type, handler, options) => {
      const base = typeof options === "boolean" ? { capture: options } : options;
      target.addEventListener(type, handler, Object.assign({}, base, { signal: globalAbort.signal }));
    };

    if (!mapEl || !window.am5 || !window.am5map || !window.am5geodata_worldLow) {
      gsap.set(".world-map", { autoAlpha: 1 });
      gsap.set(".global-copy", { autoAlpha: 1, y: 0 });
      return;
    }

    const colors = {
      paper: 0xf7f3ec,
      ink: 0x3a0903,
      neutral: 0xfffdf9,
      border: 0xddd8d0,
      orange: 0xf4511e,
      secondary: 0x8a6657,
      white: 0xffffff
    };
    const isCompactViewport = () => window.innerWidth < 760;
    const lockTouchNavigation = isCompactViewport();
    const compactMapView = isCompactViewport();

    const destinations = [
      { id: "lax", city: "Los Angeles", code: "LAX", country: "United States", countryId: "US", latitude: 33.9416, longitude: -118.4085 },
      { id: "sfo", city: "San Francisco", code: "SFO", country: "United States", countryId: "US", latitude: 37.6213, longitude: -122.379 },
      { id: "sea", city: "Seattle", code: "SEA", country: "United States", countryId: "US", latitude: 47.4502, longitude: -122.3088 },
      { id: "mia", city: "Miami", code: "MIA", country: "United States", countryId: "US", latitude: 25.7959, longitude: -80.287 },
      { id: "ord", city: "Chicago", code: "ORD", country: "United States", countryId: "US", latitude: 41.9742, longitude: -87.9073 },
      { id: "dfw", city: "Dallas", code: "DFW", country: "United States", countryId: "US", latitude: 32.8998, longitude: -97.0403 },
      { id: "atl", city: "Atlanta", code: "ATL", country: "United States", countryId: "US", latitude: 33.6407, longitude: -84.4277 },
      { id: "bos", city: "Boston", code: "BOS", country: "United States", countryId: "US", latitude: 42.3656, longitude: -71.0096 },
      { id: "yyz", city: "Toronto", code: "YYZ", country: "Canada", countryId: "CA", latitude: 43.6777, longitude: -79.6248 },
      { id: "yvr", city: "Vancouver", code: "YVR", country: "Canada", countryId: "CA", latitude: 49.1967, longitude: -123.1815 },
      { id: "mex", city: "Mexico City", code: "MEX", country: "Mexico", countryId: "MX", latitude: 19.4361, longitude: -99.0719 },
      { id: "cun", city: "Cancun", code: "CUN", country: "Mexico", countryId: "MX", latitude: 21.0365, longitude: -86.8771 },
      { id: "sju", city: "San Juan", code: "SJU", country: "Puerto Rico", countryId: "PR", latitude: 18.4394, longitude: -66.0018 },
      { id: "puj", city: "Punta Cana", code: "PUJ", country: "Dominican Republic", countryId: "DO", latitude: 18.5674, longitude: -68.3634 },
      { id: "gru", city: "Sao Paulo", code: "GRU", country: "Brazil", countryId: "BR", latitude: -23.4356, longitude: -46.4731 },
      { id: "gig", city: "Rio de Janeiro", code: "GIG", country: "Brazil", countryId: "BR", latitude: -22.8099, longitude: -43.2506 },
      { id: "eze", city: "Buenos Aires", code: "EZE", country: "Argentina", countryId: "AR", latitude: -34.8222, longitude: -58.5358 },
      { id: "scl", city: "Santiago", code: "SCL", country: "Chile", countryId: "CL", latitude: -33.393, longitude: -70.7858 },
      { id: "bog", city: "Bogota", code: "BOG", country: "Colombia", countryId: "CO", latitude: 4.7016, longitude: -74.1469 },
      { id: "lim", city: "Lima", code: "LIM", country: "Peru", countryId: "PE", latitude: -12.0219, longitude: -77.1143 },
      { id: "lhr", city: "London", code: "LHR", country: "United Kingdom", countryId: "GB", latitude: 51.47, longitude: -0.4543 },
      { id: "cdg", city: "Paris", code: "CDG", country: "France", countryId: "FR", latitude: 49.0097, longitude: 2.5479 },
      { id: "ams", city: "Amsterdam", code: "AMS", country: "Netherlands", countryId: "NL", latitude: 52.3105, longitude: 4.7683 },
      { id: "fra", city: "Frankfurt", code: "FRA", country: "Germany", countryId: "DE", latitude: 50.0379, longitude: 8.5622 },
      { id: "mad", city: "Madrid", code: "MAD", country: "Spain", countryId: "ES", latitude: 40.4983, longitude: -3.5676 },
      { id: "bcn", city: "Barcelona", code: "BCN", country: "Spain", countryId: "ES", latitude: 41.2974, longitude: 2.0833 },
      { id: "lis", city: "Lisbon", code: "LIS", country: "Portugal", countryId: "PT", latitude: 38.7742, longitude: -9.1342 },
      { id: "fco", city: "Rome", code: "FCO", country: "Italy", countryId: "IT", latitude: 41.8003, longitude: 12.2389 },
      { id: "zrh", city: "Zurich", code: "ZRH", country: "Switzerland", countryId: "CH", latitude: 47.4581, longitude: 8.5555 },
      { id: "dub", city: "Dublin", code: "DUB", country: "Ireland", countryId: "IE", latitude: 53.4213, longitude: -6.2701 },
      { id: "ath", city: "Athens", code: "ATH", country: "Greece", countryId: "GR", latitude: 37.9364, longitude: 23.9445 },
      { id: "ist", city: "Istanbul", code: "IST", country: "Turkey", countryId: "TR", latitude: 41.2753, longitude: 28.7519 },
      { id: "dxb", city: "Dubai", code: "DXB", country: "United Arab Emirates", countryId: "AE", latitude: 25.2532, longitude: 55.3657 },
      { id: "doh", city: "Doha", code: "DOH", country: "Qatar", countryId: "QA", latitude: 25.2731, longitude: 51.6081 },
      { id: "auh", city: "Abu Dhabi", code: "AUH", country: "United Arab Emirates", countryId: "AE", latitude: 24.433, longitude: 54.6511 },
      { id: "tlv", city: "Tel Aviv", code: "TLV", country: "Israel", countryId: "IL", latitude: 32.0114, longitude: 34.8867 },
      { id: "jnb", city: "Johannesburg", code: "JNB", country: "South Africa", countryId: "ZA", latitude: -26.1367, longitude: 28.2411 },
      { id: "cmn", city: "Casablanca", code: "CMN", country: "Morocco", countryId: "MA", latitude: 33.3675, longitude: -7.5899 },
      { id: "cai", city: "Cairo", code: "CAI", country: "Egypt", countryId: "EG", latitude: 30.1219, longitude: 31.4056 },
      { id: "add", city: "Addis Ababa", code: "ADD", country: "Ethiopia", countryId: "ET", latitude: 8.9779, longitude: 38.7993 },
      { id: "del", city: "Delhi", code: "DEL", country: "India", countryId: "IN", latitude: 28.5562, longitude: 77.1 },
      { id: "bom", city: "Mumbai", code: "BOM", country: "India", countryId: "IN", latitude: 19.0896, longitude: 72.8656 },
      { id: "hnd", city: "Tokyo", code: "HND", country: "Japan", countryId: "JP", latitude: 35.5494, longitude: 139.7798 },
      { id: "nrt", city: "Tokyo", code: "NRT", country: "Japan", countryId: "JP", latitude: 35.772, longitude: 140.3929 },
      { id: "icn", city: "Seoul", code: "ICN", country: "South Korea", countryId: "KR", latitude: 37.4602, longitude: 126.4407 },
      { id: "hkg", city: "Hong Kong", code: "HKG", country: "Hong Kong", countryId: "HK", latitude: 22.308, longitude: 113.9185 },
      { id: "sin", city: "Singapore", code: "SIN", country: "Singapore", countryId: "SG", latitude: 1.3644, longitude: 103.9915 },
      { id: "bkk", city: "Bangkok", code: "BKK", country: "Thailand", countryId: "TH", latitude: 13.69, longitude: 100.7501 }
    ];

    const root = am5.Root.new(mapEl);
    globalRoot = root;
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5map.MapChart.new(root, {
        panX: "none",
        panY: "none",
        wheelX: "none",
        wheelY: lockTouchNavigation ? "none" : "zoom",
        pinchZoom: !lockTouchNavigation,
        maxZoomLevel: 1.62,
        minZoomLevel: compactMapView ? 1.04 : 0.96,
        maxPanOut: 0.32,
        homeZoomLevel: compactMapView ? 1.12 : 1.04,
        homeGeoPoint: { longitude: 0, latitude: 6 },
        projection: am5map.geoNaturalEarth1(),
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0
      })
    );

    chart.chartContainer.setAll({
      interactive: !lockTouchNavigation,
      cursorOverStyle: lockTouchNavigation ? "default" : "grab"
    });
    chart.chartContainer.set("background", am5.Rectangle.new(root, {
      fill: am5.color(colors.paper),
      fillOpacity: 0,
      interactive: !lockTouchNavigation
    }));

    const polygonSeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldLow,
        exclude: ["AQ"]
      })
    );

    polygonSeries.mapPolygons.template.setAll({
      fill: am5.color(colors.neutral),
      fillOpacity: 0.96,
      stroke: am5.color(colors.border),
      strokeOpacity: 0.82,
      strokeWidth: 0.45,
      interactive: false
    });

    const routeLineSeries = chart.series.push(am5map.MapLineSeries.new(root, {}));
    routeLineSeries.mapLines.template.setAll({
      stroke: am5.color(colors.orange),
      strokeOpacity: 0,
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      interactive: false
    });

    const pointSeries = chart.series.push(am5map.MapPointSeries.new(root, {}));
    pointSeries.bullets.push((root, _series, dataItem) => {
      const radius = dataItem.get("radius") || 4;
      const isHub = Boolean(dataItem.get("isHub"));
      const container = am5.Container.new(root, {
        centerX: am5.p50,
        centerY: am5.p50,
        opacity: 0,
        scale: 0.8,
        interactive: false,
        interactiveChildren: false
      });

      if (isHub) {
        const pulse = container.children.push(
          am5.Circle.new(root, {
            radius: radius * 1.8,
            fill: am5.color(colors.orange),
            fillOpacity: 0.1,
            stroke: am5.color(colors.orange),
            strokeOpacity: 0.32,
            strokeWidth: 1.2,
            interactive: false
          })
        );
        dataItem.set("pulseSprite", pulse);
      }

      const circle = container.children.push(
        am5.Circle.new(root, {
          radius,
          fill: am5.color(dataItem.get("fill") || colors.orange),
          fillOpacity: dataItem.get("fillOpacity") ?? 1,
          stroke: am5.color(colors.white),
          strokeOpacity: dataItem.get("strokeOpacity") ?? 0.84,
          strokeWidth: dataItem.get("strokeWidth") || 1.4,
          cursorOverStyle: isHub ? "grab" : "pointer",
          interactive: false
        })
      );

      dataItem.set("pointSprite", container);
      dataItem.set("circleSprite", circle);

      return am5.Bullet.new(root, {
        sprite: container
      });
    });

    const jfkPoint = pointSeries.pushDataItem({
      id: "jfk",
      latitude: 40.6413,
      longitude: -73.7781,
      radius: 6.8,
      isHub: true,
      fill: colors.orange,
      fillOpacity: 1,
      strokeOpacity: 0.95,
      strokeWidth: 2
    });

    const destinationPoints = destinations.map((destination) =>
      pointSeries.pushDataItem({
        id: destination.id,
        latitude: destination.latitude,
        longitude: destination.longitude,
        radius: 2.9,
        city: destination.city,
        code: destination.code,
        country: destination.country,
        countryId: destination.countryId,
        fill: colors.secondary,
        fillOpacity: destination.countryId === "BR" ? 0.8 : 0.68,
        strokeOpacity: 0.48,
        strokeWidth: 0.8
      })
    );

    function createRoute(from, to, options = {}) {
      const fromPoint = { latitude: from.get("latitude"), longitude: from.get("longitude") };
      const toPoint = { latitude: to.get("latitude"), longitude: to.get("longitude") };
      const line = routeLineSeries.pushDataItem({
        geometry: {
          type: "LineString",
          coordinates: createRouteCoordinates(fromPoint, toPoint)
        }
      });
      const route = {
        line,
        to,
        countryId: to.get("countryId"),
        opacity: options.opacity || 0.26,
        progress: 0,
        strokeWidth: options.strokeWidth || 0.95
      };
      to.set("routeRef", route);
      return route;
    }

    const globalRoutes = destinationPoints.map((destination) =>
      createRoute(jfkPoint, destination, { opacity: 0.28, strokeWidth: 0.92 })
    );

    let hoveredRoute = null;
    const tooltipEl = document.createElement("div");
    const manualPan = {
      enabled: !lockTouchNavigation,
      active: false,
      pointerId: null,
      lastX: 0,
      lastY: 0
    };

    tooltipEl.className = "global-map-tooltip";
    tooltipEl.setAttribute("aria-hidden", "true");
    mapEl.closest(".world-map")?.appendChild(tooltipEl);

    function endDrag() {
      stopManualPan();
    }

    on(window, "pointerup", endDrag);
    on(window, "pointercancel", endDrag);

    on(mapEl, "pointerleave", () => {
      setHoveredRoute(null);
      hideDestinationTooltip();
    });

    on(mapEl, "pointermove", (event) => {
      if (manualPan.active) {
        setHoveredRoute(null);
        hideDestinationTooltip();
        return;
      }

      const hit = getDestinationAtPointer(event);

      if (!hit) {
        setHoveredRoute(null);
        hideDestinationTooltip();
        return;
      }

      setHoveredRoute(hit.route);
      showDestinationTooltip(hit.route, hit.point);
    });

    on(mapEl, "pointerdown", (event) => {
      if (!manualPan.enabled || (event.button != null && event.button !== 0)) return;
      startManualPan(event.clientX, event.clientY, event.pointerId);
      mapEl.setPointerCapture?.(event.pointerId);
      event.preventDefault();
      event.stopPropagation();
    }, true);

    on(window, "pointermove", (event) => {
      if (!manualPan.active || (manualPan.pointerId != null && event.pointerId !== manualPan.pointerId)) return;
      panMapFallback(event.clientX, event.clientY);
      event.preventDefault();
    }, { capture: true, passive: false });

    on(mapEl, "mousedown", (event) => {
      if (!manualPan.enabled || manualPan.active || event.button !== 0) return;
      startManualPan(event.clientX, event.clientY, null);
      event.preventDefault();
      event.stopPropagation();
    }, true);

    on(mapEl, "touchstart", (event) => {
      if (!manualPan.enabled || manualPan.active || event.touches.length !== 1) return;
      startManualPan(event.touches[0].clientX, event.touches[0].clientY, null);
      event.preventDefault();
      event.stopPropagation();
    }, { capture: true, passive: false });

    on(window, "mousemove", (event) => {
      if (!manualPan.active) return;
      panMapFallback(event.clientX, event.clientY);
      event.preventDefault();
    }, { passive: false });

    on(window, "touchmove", (event) => {
      if (!manualPan.active || !event.touches.length) return;
      panMapFallback(event.touches[0].clientX, event.touches[0].clientY);
      event.preventDefault();
    }, { passive: false });

    on(window, "mouseup", stopManualPan);
    on(window, "touchend", stopManualPan);
    on(window, "touchcancel", stopManualPan);

    function startManualPan(clientX, clientY, pointerId) {
      manualPan.active = true;
      manualPan.pointerId = pointerId;
      manualPan.lastX = clientX;
      manualPan.lastY = clientY;
      mapEl.classList.add("is-dragging");
      setHoveredRoute(null);
      hideDestinationTooltip();
    }

    function stopManualPan() {
      manualPan.active = false;
      manualPan.pointerId = null;
      mapEl.classList.remove("is-dragging");
    }

    function panMapFallback(clientX, clientY) {
      const deltaX = clientX - manualPan.lastX;
      const deltaY = clientY - manualPan.lastY;

      manualPan.lastX = clientX;
      manualPan.lastY = clientY;

      chart.setAll({
        translateX: (chart.get("translateX") || 0) + deltaX,
        translateY: (chart.get("translateY") || 0) + deltaY
      });
    }

    function escapeHtml(value) {
      const scratch = document.createElement("span");
      scratch.textContent = value;
      return scratch.innerHTML;
    }

    function getProjectedPoint(dataItem) {
      const point = chart.convert({
        latitude: dataItem.get("latitude"),
        longitude: dataItem.get("longitude")
      });

      return Number.isFinite(point?.x) && Number.isFinite(point?.y) ? point : null;
    }

    function getDestinationAtPointer(event) {
      const rect = mapEl.getBoundingClientRect();
      const pointer = {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
      };
      let nearest = null;

      globalRoutes.forEach((route) => {
        if (route.progress < 0.72) return;

        const point = getProjectedPoint(route.to);
        if (!point) return;

        const distance = Math.hypot(pointer.x - point.x, pointer.y - point.y);
        if (distance <= 12 && (!nearest || distance < nearest.distance)) {
          nearest = { route, point, distance };
        }
      });

      return nearest;
    }

    function showDestinationTooltip(route, point) {
      const city = escapeHtml(route.to.get("city") || "");
      const code = escapeHtml(route.to.get("code") || "");
      const country = escapeHtml(route.to.get("country") || "");
      const mapRect = mapEl.getBoundingClientRect();
      const tooltipWidth = 168;
      const left = gsap.utils.clamp(10, mapRect.width - tooltipWidth - 10, point.x + 14);
      const top = gsap.utils.clamp(10, mapRect.height - 72, point.y - 14);

      tooltipEl.innerHTML = `<strong>${city}</strong><span>${code} · ${country}</span>`;
      tooltipEl.style.transform = `translate(${left}px, ${top}px)`;
      tooltipEl.classList.add("is-visible");
      tooltipEl.setAttribute("aria-hidden", "false");
    }

    function hideDestinationTooltip() {
      tooltipEl.classList.remove("is-visible");
      tooltipEl.setAttribute("aria-hidden", "true");
    }

    function createRouteCoordinates(from, to) {
      const longitudeDelta = to.longitude - from.longitude;
      const latitudeDelta = to.latitude - from.latitude;
      const distance = Math.hypot(longitudeDelta, latitudeDelta);
      const normalLength = Math.max(distance, 1);
      const normalX = -latitudeDelta / normalLength;
      const normalY = longitudeDelta / normalLength;
      const signedBend = to.longitude >= from.longitude ? 1 : -1;
      const bend = gsap.utils.clamp(2.6, 18, distance * 0.115);
      const coordinates = [];

      for (let index = 0; index <= 40; index += 1) {
        const t = index / 40;
        const lift = Math.sin(Math.PI * t) * bend * signedBend;
        const longitude = from.longitude + longitudeDelta * t + normalX * lift;
        const latitude = from.latitude + latitudeDelta * t + normalY * lift;
        coordinates.push([longitude, latitude]);
      }

      coordinates[0] = [from.longitude, from.latitude];
      coordinates[coordinates.length - 1] = [to.longitude, to.latitude];

      return coordinates;
    }

    function mixColor(from, to, amount) {
      const ratio = gsap.utils.clamp(0, 1, amount);
      const fromRgb = [(from >> 16) & 255, (from >> 8) & 255, from & 255];
      const toRgb = [(to >> 16) & 255, (to >> 8) & 255, to & 255];
      const mixed = fromRgb.map((channel, index) => Math.round(channel + (toRgb[index] - channel) * ratio));
      return (mixed[0] << 16) | (mixed[1] << 8) | mixed[2];
    }

    function getCountry(id) {
      return polygonSeries.getDataItemById(id)?.get("mapPolygon");
    }

    function setCountry(id, amount, maxOpacity = 0.88) {
      const polygon = getCountry(id);
      if (!polygon) return;

      const color = mixColor(colors.neutral, colors.orange, amount);
      polygon.setAll({
        fill: am5.color(color),
        fillOpacity: 0.96 + amount * (maxOpacity - 0.96),
        stroke: am5.color(colors.border),
        strokeOpacity: 0.82
      });
    }

    function setPoint(dataItem, amount, scale = 1) {
      const sprite = dataItem.get("pointSprite");
      if (!sprite) return;

      sprite.setAll({
        opacity: amount,
        scale: 0.78 + amount * (scale - 0.78)
      });
    }

    function setRoute(route, progress) {
      const clamped = gsap.utils.clamp(0, 1, progress);
      const line = route.line.get("mapLine");
      const isHovered = hoveredRoute === route;
      const hasHover = Boolean(hoveredRoute);
      const opacity = clamped <= 0 ? 0 : route.opacity * (hasHover && !isHovered ? 0.24 : 1);
      const strokeWidth = route.strokeWidth * (isHovered ? 1.85 : 1);

      if (line) {
        line.setAll({
          strokeOpacity: isHovered ? Math.max(opacity, 0.88) : opacity,
          strokeWidth
        });
      }
    }

    function setHub(dataItem, amount, pulseAmount) {
      setPoint(dataItem, amount, 1.18);

      const pulse = dataItem.get("pulseSprite");
      if (!pulse) return;

      const clampedPulse = gsap.utils.clamp(0, 1, pulseAmount);
      pulse.setAll({
        opacity: amount * (1 - clampedPulse) * 0.85,
        fillOpacity: 0.08 * (1 - clampedPulse),
        strokeOpacity: 0.34 * (1 - clampedPulse),
        scale: 0.58 + clampedPulse * 1.35
      });
    }

    function setDestination(route, progress) {
      const circle = route.to.get("circleSprite");
      const isHovered = hoveredRoute === route;
      const hasHover = Boolean(hoveredRoute);
      const amount = gsap.utils.clamp(0, 1, (progress - 0.72) / 0.2);

      setPoint(route.to, amount, isHovered ? 1.34 : 1);

      if (circle) {
        circle.setAll({
          fill: am5.color(isHovered ? colors.orange : colors.secondary),
          fillOpacity: isHovered ? 1 : route.to.get("fillOpacity"),
          strokeOpacity: isHovered ? 0.94 : hasHover ? 0.3 : route.to.get("strokeOpacity"),
          strokeWidth: isHovered ? 1.4 : route.to.get("strokeWidth")
        });
      }
    }

    function setHoveredRoute(route) {
      if (hoveredRoute === route) return;
      hoveredRoute = route;
      renderState();
    }

    const state = {
      jfk: 0,
      jfkPulse: 0
    };

    function renderState() {
      setCountry("US", state.jfk * 0.16, 0.982);
      setHub(jfkPoint, state.jfk, state.jfkPulse);

      globalRoutes.forEach((route) => {
        setRoute(route, route.progress);
        setDestination(route, route.progress);
      });
    }

    function setupTimeline() {
      root.events.on("frameended", renderState);
      renderState();

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".global-final",
          start: "top 82%",
          end: "center 48%",
          scrub: 0.18,
          invalidateOnRefresh: true
        }
      });

      tl
        .to(state, { jfk: 1, duration: 0.34, onUpdate: renderState })
        .to(state, { jfkPulse: 1, duration: 0.42, ease: "power2.out", onUpdate: renderState }, "<")
        .addLabel("globalRoutes");

      globalRoutes.forEach((route, index) => {
        tl.to(route, {
          progress: 1,
          duration: 0.42,
          ease: "power1.inOut",
          onUpdate: renderState
        }, `globalRoutes+=${(index * 0.026).toFixed(3)}`);
      });

      tl
        .from(".global-copy", { y: 22, autoAlpha: 0, duration: 0.28, immediateRender: false }, "globalRoutes+=0.72")
        .to(".global-title", { scale: 1.05, duration: 0.28, ease: "none" }, "globalRoutes+=0.72");

      ScrollTrigger.refresh();
    }

    gsap.set(".world-map", { autoAlpha: 0, clipPath: "inset(0 50% 0 50%)", scale: 0.98 });
    gsap.to(".world-map", {
      autoAlpha: 1,
      clipPath: "inset(0 0% 0 0%)",
      scale: 1,
      duration: 0.7,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".global-final",
        start: "top 82%",
        toggleActions: "play none none reverse"
      }
    });

    polygonSeries.events.once("datavalidated", () => {
      chart.goHome(0);
      root.events.once("frameended", () => {
        if (globalContext) {
          globalContext.add(setupTimeline);
        } else {
          setupTimeline();
        }
      });
    });
  }

  async function init() {
    await initHero();
    initEcosystem();
    initServiceDetails();
    initOkBreak();
    initMarketComparison();
    initEcommerceGrowth();
    initOperationFlow();
    try {
      initProjectWall();
    } catch (error) {
      projectWallContext?.revert();
    }
    initCaseShowcase();
    initProjectCases();
    initClients();
    initGlobal();
    initGenericReveals();
    initCharts();
    initBrandStory();
    refreshScrollAnimations();
    scheduleScrollAnimationRefresh(160);
    scheduleScrollAnimationRefresh(520);
    document.fonts?.ready.then(() => scheduleScrollAnimationRefresh());

    if (shouldForceStartupTop) {
      [0, 60, 180, 520].forEach((delay) => {
        window.setTimeout(forcePageTop, delay);
      });
    }

    const startupTarget = getStartupAnchorTarget();
    if (startupTarget) {
      lockPendingAnchor(startupTarget, 2600);
      [0, 120, 360, 700, 1200, 2000].forEach((delay) => {
        window.setTimeout(() => applyPendingAnchor(), delay);
      });
    }
  }

  const viewportRebuildTargets = [
    initEcosystem,
    initMarketComparison,
    initEcommerceGrowth,
    initOperationFlow,
    initProjectWall,
    initCaseShowcase,
    initPkxdCase,
    initApisvidaCase,
    initGlobal
  ];
  let viewportRebuildTimer;

  function rebuildViewportSections() {
    window.clearTimeout(viewportRebuildTimer);
    viewportRebuildTimer = window.setTimeout(() => {
      viewportRebuildTargets.forEach((rebuild) => {
        try {
          rebuild();
        } catch (error) {
          /* uma secao que falhe nao pode impedir as outras de reconstruir */
        }
      });
      refreshScrollAnimations();
    }, 200);
  }

  ["(max-width: 760px)", "(max-width: 1023px)", "(max-width: 1100px)"].forEach((breakpoint) => {
    window.matchMedia(breakpoint).addEventListener("change", rebuildViewportSections);
  });

  window.addEventListener("pageshow", () => {
    if (shouldForceStartupTop) {
      forcePageTop();
      window.setTimeout(forcePageTop, 180);
    }
    scheduleScrollAnimationRefresh();
    scheduleScrollAnimationRefresh(180);
  });

  window.addEventListener("beforeunload", () => {
    try {
      sessionStorage.setItem(reloadScrollTopKey, "1");
    } catch (error) {
      /* sessionStorage pode estar indisponivel em alguns previews */
    }
    window.scrollTo(0, 0);
  });

  window.addEventListener("load", init);
})();
